import React, {
  useState,
  useRef, // Changed from default React imports or createRef to useRef
  useEffect,
  useMemo,
  useCallback,
  useLayoutEffect,
} from "react";
import { withTranslation } from "react-i18next";
import * as moment from "moment";
import { generateWeek, encodeId } from "utils";
import { cloneDeep, findKey } from "lodash";
import constants from "../../../../../../../constants.js";
import defautUserImage from "assets/images/staff-default.svg";
import HolidayImage from "assets/images/early_on.svg";
import Loader from "components/Loader";
import toast from "react-hot-toast";
import Empty from "components/Empty";
import {
  filterEventsBySearch,
  filteringMethodForEventShiftOthers,
  leaveClasses,
} from "accountOwner/pages/Scheduler/scheduler.function";
import {
  renderOfficeNameOrEnterprise,
  setterCustomSchduler,
  setterPublishOffices,
  matchedBothPatternValues,
  matchedBothDatesValues,
} from "accountOwner/pages/AddEvent/addEvents.functions";
import { addEditEventsConst } from "accountOwner/pages/AddEvent/addEvents.constants";
import EditOptionsModal, {
  editTypesVariables,
} from "accountOwner/pages/EditEvent/EditOptionsModal";
import styles from "../StaffAvailabilityTab.module.scss";
import schedulerStyles from "../../../../Scheduler.module.scss";
import { Tooltip, Col, Row } from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";
import { useAccountOwnerCommon } from "lib/Context/AccountOwner";
import Text from "components/Text";
import {
  useGetOfficeAgenda,
  updateBusySlot,
  useCreateUpdateSchedulerEventMutation,
  getEventListDetails,
  getBusySlot,
} from "repositories/scheduler-repository";
import { useQueryClient } from "react-query";
import { getOfficeDetail } from "repositories/office-repository";
import CloseIcon from "assets/images/cross.svg";
import { showTime } from "accountOwner/pages/Scheduler/OfficeSchedulerTab/SubTabs/EventsShiftsTab";
import { useParams } from "react-router-dom/cjs/react-router-dom.min.js";

const HOUR_CELL_HEIGHT_PX = 60; // Assumed fixed height for each hour row
const MIN_EVENT_HEIGHT_PX = 8; // Minimum height for any event

// Default dark color when officeColourCodes is null
const DEFAULT_DARK_COLOR = "#2D3245";
// Owner color
const OWNER_COLOR = "#8c0346";

const getOfficeColor = (user, selectedOwnerId) => {
  // Check if user is owner
  if (user?.id === selectedOwnerId) {
    return OWNER_COLOR;
  }

  // Get color from officeColourCodes
  const officeColor = user?.officeColourCodes;

  // If officeColourCodes is null or undefined, return default dark color
  if (!officeColor) {
    return DEFAULT_DARK_COLOR;
  }

  return officeColor;
};

function WeeklyListView({
  t,
  currentDate,
  selectedOwnerId,
  currentUserId,
  apiOffices = [],
  apiEmps = [],
  agendaTypes = [],
  cachedEventFilter =[],
  viewSettingFilter =[],
  searchValue = "",
  isEnterpriseFilterActive = false,
  isFreeStotLoading = false,
  canShowOfficeName = true,
  onDateChange,
  context = "",
  selectedStaff =[],
  onTimeLabelClick,
  selectedHourIdx,
  startTime,
  showFreeSlots,
  onFreeSlotClick,
  findAvailabilityData = null,
  resetFocusRef,
  focusOnFirstAvailableSlot,
}) {
  const isSchedulingAssistant = useMemo(
    () => context === "scheduling-assistant",
    [],
  );

  const[position, setPosition] = useState({ left: 0, top: 0 });
  const[showPopup, setShowPopup] = useState(false);
  const [weekData, setWeekData] = useState([]);
  const[dateRange, setDateRange] = useState(null);
  const [agendaFilter, setAgendaFilter] = useState([]);
  const [openTooltipId, setOpenTooltipId] = useState(null);
  const[hoverKey, setHoverKey] = useState("");
  const [draggedEvent, setDraggedEvent] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const[dragPreviewPosition, setDragPreviewPosition] = useState(null);
  const[editModalConfirmation, setEditModalConfirmation] = useState(false);
  const [pendingDragUpdate, setPendingDragUpdate] = useState(null);
  const [isDragDropLoading, setIsDragDropLoading] = useState(false);
  const history = useHistory();
  const { eventId: eventIdFromUrl } = useParams();
  const { profile, isStaff, isOwner, dataAccessValues, effectiveOwnerIdString } =
    useAccountOwnerCommon();
  const draggedEventDateRef = useRef(null);
  const createSchedulerEventMutation = useCreateUpdateSchedulerEventMutation();
  const queryClient = useQueryClient();

  // Ref for the table container
  const tableContainerRef = useRef(null);
  // Ref for the Calendar Wrapper (for dynamic height)
  const calendarWrapperRef = useRef(null);
  // Ref for the current hour row
  const currentHourRowRef = useRef(null);

  // Refs for dynamic calculation
  const measurementContainerRef = useRef(null);
  const dummyMoreBtnRef = useRef(null);

  // State for dynamic table height calculation
  const[tableHeight, setTableHeight] = useState("auto");

  // --- START OF DYNAMIC HEIGHT CALCULATION ---
  useEffect(() => {
    const calculateDynamicHeight = () => {
      if (calendarWrapperRef.current) {
        // Get the distance of the container from the top of the viewport
        const rect = calendarWrapperRef.current.getBoundingClientRect();
        const viewportHeight = window.innerHeight;

        // Find the specific wrapper based on client instructions:
        // Look for .scheduler-tabs or .Dashboard_box to check boundaries.
        // Fallback to document.body if neither is found.
        const wrapper =
          calendarWrapperRef.current.closest(".scheduler-tabs") ||
          calendarWrapperRef.current.closest(".Dashboard_box") ||
          document.body;

        // Default limit is the bottom of the viewport
        let limitBottom = viewportHeight;

        // If the wrapper is found, check if its bottom is visible within the viewport
        if (wrapper) {
          const wrapperRect = wrapper.getBoundingClientRect();
          // If the wrapper's bottom is ABOVE the viewport bottom (meaning we scrolled past it or it's short),
          // use the wrapper's bottom as the limit.
          if (wrapperRect.bottom < viewportHeight) {
            limitBottom = wrapperRect.bottom - 5;
          }
        }

        // Calculate maxHeight: The distance from the top of the table (rect.top)
        // to the limit (either screen bottom or wrapper bottom).
        let computedHeight = limitBottom - rect.top - 20;

        // Minimum safety check to prevent it from disappearing
        if (computedHeight < 200) computedHeight = 200;

        setTableHeight(`${computedHeight}px`);
      }
    };

    // Calculate on mount and shortly after
    calculateDynamicHeight();
    const timeoutId = setTimeout(calculateDynamicHeight, 100);

    // Attach listeners
    window.addEventListener("resize", calculateDynamicHeight);
    window.addEventListener("scroll", calculateDynamicHeight, {
      passive: true,
    });

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("resize", calculateDynamicHeight);
      window.removeEventListener("scroll", calculateDynamicHeight);
    };
  },[]);
  // --- END OF DYNAMIC HEIGHT CALCULATION ---

  // Get the hour to scroll to: use startTime if present, else current hour
  let scrollHour = null;
  if (startTime) {
    scrollHour = moment.isMoment(startTime)
      ? startTime.hour()
      : moment(startTime, ["h:mm A", "HH:mm"]).hour();
  } else {
    scrollHour = moment().hour();
  }

  const canEditAndViewOthersData = useCallback(
    (officeId) => {
      if (isStaff) {
        return (
          dataAccessValues?.officeList?.some(
            (res) => res.officeId === officeId && res.isAdmin,
          ) || false
        );
      }
      return isOwner;
    },[isStaff, isOwner, dataAccessValues?.officeList],
  );

  const toggleTooltip = (id) => {
    setOpenTooltipId((prev) => (prev === id ? null : id));
  };

  const resetHoverKey = useCallback((e) => {
    e.stopPropagation();
    setHoverKey("");
  },[]);

  const containerRef = useRef(null);
  const popupRef = useRef(null);
  const highlightRef = useRef(null);
  const firstAvailabilitySlotRef = useRef(null);
  const { search } = useLocation();

  // Get date from URL search params for highlighting
  const dateMatchForHighlight = useMemo(() => {
    const searchValue = new URLSearchParams(search).get(showTime);
    if (searchValue?.includes("NaN") || !search) {
      return null;
    }
    return new Date(+searchValue);
  }, [search]);

  // Generate week dates (Sunday to Saturday)
  useEffect(() => {
    if (currentDate) {
      const selectedStartWeek = moment(currentDate).startOf("week"); // Sunday
      const selectedEndWeek = moment(currentDate).endOf("week"); // Saturday
      const currentweekData = generateWeek(selectedStartWeek, selectedEndWeek);
      setDateRange({
        startDate: moment(selectedStartWeek).format("YYYY-MM-DD"),
        endDate: moment(selectedEndWeek).format("YYYY-MM-DD"),
      });
      setWeekData(currentweekData);
    }
  }, [currentDate]);

  // Filter agenda by events
  const filterByEvents = (agendaData) => {
    if (!agendaData) return[];
    const updatedAgenda = agendaData.map((item) => {
      const schedulerList = Array.isArray(item.officeSchedulerList)
        ? item.officeSchedulerList
        : [item.officeSchedulerList];

      const filteredSchedulerList = schedulerList.map((schedulerItem) =>
        filteringMethodForEventShiftOthers(
          agendaTypes,
          schedulerItem,
          currentUserId,
        ),
      );

      return {
        ...item,
        officeSchedulerList: filteredSchedulerList,
      };
    });
    return updatedAgenda;
  };

  // Fetch agenda data
  const enableFetch = Boolean(
    selectedOwnerId && dateRange?.startDate && dateRange?.endDate,
  );

  const {
    isLoading,
    isFetching,
    data: weeklyData,
    error,
  } = useGetOfficeAgenda(
    selectedOwnerId,
    dateRange?.startDate,
    dateRange?.endDate,
    apiOffices,
    apiEmps,
    { enabled: enableFetch },
  );

  useEffect(() => {
    if (!isLoading && weeklyData?.data) {
      if (cachedEventFilter?.length > 0) {
        setAgendaFilter([...filterByEvents(weeklyData.data)]);
      } else if (cachedEventFilter?.length === 0) {
        setAgendaFilter([...weeklyData.data]);
      }
    }
  }, [isLoading, weeklyData?.data, cachedEventFilter]);

  useEffect(() => {
    if (!isLoading && !isFetching && error?.message) {
      toast.error(error.message);
    }
  }, [error, isLoading, isFetching]);

  // Apply enterprise filter
  let filteredAgendaFilter = agendaFilter;
  if (isEnterpriseFilterActive) {
    filteredAgendaFilter = (agendaFilter ||[]).map((date) => {
      const filteredOfficeSchedulerList = (date.officeSchedulerList ||[]).map(
        (item) => ({
          ...item,
          appointments: (item.appointments ||[]).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          leaves: (item.leaves ||[]).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          schedulerBusySlots: (item.schedulerBusySlots ||[]).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          schedulerEvents: (item.schedulerEvents ||[]).filter(
            (e) => e && e?.isEnterprise === true,
          ),
          appointmentSlots: (item.appointmentSlots ||[]).filter(
            (e) => e && e?.isEnterprise === true,
          ),
        }),
      );
      return {
        ...date,
        officeSchedulerList: filteredOfficeSchedulerList,
      };
    });
  }

  // Process user data from agenda
  const userData = useMemo(() => {
    if (!filteredAgendaFilter?.length) return [];

    const users = cloneDeep(filteredAgendaFilter[0].officeSchedulerList).map(
      (item) => ({
        user: item.user,
        data:[],
      }),
    );

    filteredAgendaFilter.forEach((date) => {
      const { requestedDate, officeSchedulerList } = date;
      officeSchedulerList.forEach((data, userIndex) => {
        const { user, ...rest } = data;
        if (users[userIndex]) {
          users[userIndex].data.push({ requestedDate, ...rest });
        }
      });
    });

    return users;
  }, [filteredAgendaFilter]);

  // Generate office list with colors
  const officeList = useMemo(() => {
    return userData.map((ud, index) => {
      const { user } = ud;
      const officeColor = getOfficeColor(user, selectedOwnerId);

      return {
        id: user?.id,
        name: user?.fullName || "",
        office: user?.officeNames?.join(", ") || "",
        color: officeColor,
        dotColor: officeColor, // Use same color for dots
        profilePic: user?.profilePic,
      };
    });
  },[userData, selectedOwnerId]);

  const [visibleCount, setVisibleCount] = useState(5);

  useLayoutEffect(() => {
    const calculateVisibleItems = () => {
      if (
        !tableContainerRef.current ||
        !measurementContainerRef.current ||
        officeList.length === 0
      )
        return;

      const containerStyle = window.getComputedStyle(tableContainerRef.current);
      // Available width excludes padding
      const containerWidth =
        tableContainerRef.current.clientWidth -
        (parseFloat(containerStyle.paddingLeft) || 0) -
        (parseFloat(containerStyle.paddingRight) || 0);

      // Get children from the measurement container
      const children = Array.from(measurementContainerRef.current.children);

      // Separate actual items and the dummy button (last item)
      const chipNodes = children.slice(0, officeList.length);
      const moreBtnNode = dummyMoreBtnRef.current;

      // Calculate width of "More" button including margins
      let moreBtnWidth = 0;
      if (moreBtnNode) {
        const rect = moreBtnNode.getBoundingClientRect();
        const style = window.getComputedStyle(moreBtnNode);
        moreBtnWidth =
          rect.width +
          (parseFloat(style.marginLeft) || 0) +
          (parseFloat(style.marginRight) || 0);
      }

      // Determine gap dynamically from the measurement container layout
      let gap = 10; // Fallback
      if (chipNodes.length >= 2) {
        const first = chipNodes[0].getBoundingClientRect();
        const second = chipNodes[1].getBoundingClientRect();
        gap = second.left - first.right;
      }

      let currentWidth = 0;
      let count = 0;

      // 1. Check if all items fit without the button
      let allFit = true;
      let totalWidth = 0;
      for (let i = 0; i < chipNodes.length; i++) {
        const node = chipNodes[i];
        const rect = node.getBoundingClientRect();
        // Include margin if any (though usually gap handles spacing in flex)
        // Since we use max-content flex, rect.width is precise.
        // We add gap only between items.
        totalWidth += rect.width;
        if (i < chipNodes.length - 1) totalWidth += gap;
      }

      if (totalWidth <= containerWidth) {
        setVisibleCount(officeList.length);
        return;
      }

      // 2. Iterate to find how many fit WITH the button
      for (let i = 0; i < chipNodes.length; i++) {
        const node = chipNodes[i];
        const rect = node.getBoundingClientRect();
        const itemWidth = rect.width;

        // Space needed if we include this item + gap + button
        // Note: gap is needed between this item and the button
        const nextWidth = currentWidth + itemWidth;
        const widthWithButton = nextWidth + gap + moreBtnWidth;

        if (widthWithButton > containerWidth) {
          break;
        }

        currentWidth += itemWidth + gap;
        count++;
      }

      // Ensure at least 1 item shows if possible
      setVisibleCount(Math.max(1, count));
    };

    calculateVisibleItems();

    const resizeObserver = new ResizeObserver(() => {
      calculateVisibleItems();
    });

    if (tableContainerRef.current) {
      resizeObserver.observe(tableContainerRef.current);
    }
    // Also observe the measurement container to catch font loads/reflows
    if (measurementContainerRef.current) {
      resizeObserver.observe(measurementContainerRef.current);
    }

    return () => resizeObserver.disconnect();
  }, [officeList]);

  const visibleOffices = officeList.slice(0, visibleCount);
  const hiddenOffices = officeList.slice(visibleCount);

  // Generate days from week data
  const days = useMemo(() => {
    return weekData.map((day) => ({
      date: day.mDate,
      momentDate: day.date,
    }));
  }, [weekData]);

  // Generate hours (12 AM to 11 PM - 24 hours)
  const hours = useMemo(() => {
    const hourList =[];
    for (let i = 0; i <= 23; i++) {
      const hour = moment().hour(i).minute(0);
      hourList.push({
        label: hour.format("h A"),
        moment: hour,
        hour: i,
      });
    }
    return hourList;
  },[]);

  // Helper function to get all staff events (similar to SchedulingTable)
  const getAllStaffEvents = useCallback((scheduler) => {
    const events =[];

    // Add scheduler events
    if (scheduler.schedulerEvents) {
      events.push(
        ...scheduler.schedulerEvents.map((event) => ({
          ...event,
          type: "schedulerEvent",
        })),
      );
    }

    // Add appointment slots
    if (scheduler.appointmentSlots) {
      events.push(
        ...scheduler.appointmentSlots.map((slot) => ({
          ...slot,
          type: "appointmentSlot",
          title: slot.reasonForBlock || "Appointment Slot",
        })),
      );
    }

    // Add busy slots
    if (scheduler.schedulerBusySlots) {
      events.push(
        ...scheduler.schedulerBusySlots.map((slot) => ({
          ...slot,
          type: "busySlot",
          isBusySlot: true,
          title: slot.title || "Busy",
        })),
      );
    }

    // Add appointments
    if (scheduler.appointments) {
      events.push(
        ...scheduler.appointments.map((appointment) => ({
          ...appointment,
          type: "appointment",
          title: appointment.description || "Appointment",
        })),
      );
    }

    // Add leaves
    if (scheduler.leaves) {
      events.push(
        ...scheduler.leaves.map((leave) => ({
          ...leave,
          type: "leave",
          isAllDayEvent: true, // Ensure leaves are treated as all-day events
          title: leave.reason || "Leave",
        })),
      );
    }

    return events;
  },[]);

  // Categorize events into all-day and time-based (similar to SchedulingTable)
  const categorizeEvents = useCallback((events) => {
    return {
      allDayEvents: events.filter(
        (event) =>
          event.isAllDayEvent ||
          event.isAllDayBusy ||
          (event.startTime &&
            event.endTime &&
            new Date(event.startTime).toDateString() !==
              new Date(event.endTime).toDateString()),
      ),
      timeEvents: events.filter(
        (event) =>
          !event.isAllDayEvent &&
          !event.isAllDayBusy &&
          event.startTime &&
          event.endTime &&
          new Date(event.startTime).toDateString() ===
            new Date(event.endTime).toDateString(),
      ),
    };
  },[]);

  // Get event colors based on type (moved before useMemo to be accessible)
  const getEventColor = useCallback(
    (event) => {
      if (!event || !event.agendaType) {
        return "#c7e9ff"; // Default color
      }
      const pendingCheck =
        event?.statusId === constants.agendaType.PENDINGLEAVE;

      switch (event.agendaType) {
        case constants.agendaType.LEAVE:
          return pendingCheck ? "#fdeded" : "rgba(113, 213, 185, 0.2)";
        case constants.agendaType.BUSY_SLOT:
        case constants.agendaType.BLOCKED:
          return "#fef3d7";
        case constants.agendaType.EVENT:
          if (event.eventStatus === constants.SCHEDULERSTATUS.PENDING) {
            return "#e1f4fd";
          } else if (currentUserId === event.createdById) {
            return "#f9fcee";
          } else {
            return "#f2f3ef";
          }
        case constants.agendaType.APPOINTMENT:
          return "#f6f1fd";
        default:
          return "#c7e9ff";
      }
    },
    [currentUserId],
  );

  const getEventBorderColor = useCallback(
    (event) => {
      if (!event || !event.agendaType) {
        return "#005f99"; // Default border color
      }
      const pendingCheck =
        event?.statusId === constants.agendaType.PENDINGLEAVE;
      switch (event.agendaType) {
        case constants.agendaType.LEAVE:
          return pendingCheck ? "#ff5757" : "#71d5b9";
        case constants.agendaType.BUSY_SLOT:
        case constants.agendaType.BLOCKED:
          return "#f7cb7a";
        case constants.agendaType.EVENT:
          if (event.eventStatus === constants.SCHEDULERSTATUS.PENDING) {
            return "#82d8f8";
          } else if (currentUserId === event.createdById) {
            return "#f7cb7a";
          } else {
            return "#707070";
          }
        case constants.agendaType.APPOINTMENT:
          return "#d8b4f8";
        default:
          return "#005f99";
      }
    },
    [currentUserId],
  );

  // Helper function to map background color to CSS class
  const getBackgroundColorClass = useCallback(
    (eventItem) => {
      if (!eventItem || !eventItem.agendaType) {
        return "color-blue";
      }

      const pendingCheck =
        eventItem?.statusId === constants.agendaType.PENDINGLEAVE;

      switch (eventItem.agendaType) {
        case constants.agendaType.LEAVE:
          // Use leaveClasses for leaves
          return pendingCheck ? "red-bg" : "green-bg";
        case constants.agendaType.BUSY_SLOT:
        case constants.agendaType.BLOCKED:
          return "light-orange-bg";
        case constants.agendaType.EVENT:
          if (eventItem.eventStatus === constants.SCHEDULERSTATUS.PENDING) {
            return "color-blue";
          } else if (currentUserId === eventItem.createdById) {
            return ""; // Empty string for events created by user (default background)
          } else {
            return "color-grey";
          }
        case constants.agendaType.APPOINTMENT:
          return "light-purple-bg";
        default:
          return "color-blue";
      }
    },
    [currentUserId],
  );

  // Helper function to map tag/border color to CSS class
  const getTagColorClass = useCallback(
    (eventItem) => {
      if (!eventItem || !eventItem.agendaType) {
        return "theme-green-bg";
      }

      const pendingCheck =
        eventItem?.statusId === constants.agendaType.PENDINGLEAVE;

      switch (eventItem.agendaType) {
        case constants.agendaType.LEAVE:
          // Use leaveClasses for leaves
          return pendingCheck ? "dark-red-bg" : "dark-green-bg";
        case constants.agendaType.BUSY_SLOT:
        case constants.agendaType.BLOCKED:
          return "dark-orange-bg";
        case constants.agendaType.EVENT:
          if (eventItem.eventStatus === constants.SCHEDULERSTATUS.PENDING) {
            return "theme-green-bg";
          } else if (currentUserId === eventItem.createdById) {
            return "theme-green-bg";
          } else {
            return "dark-grey-bg";
          }
        case constants.agendaType.APPOINTMENT:
          return "dark-grey-bg";
        default:
          return "theme-green-bg";
      }
    },
    [currentUserId],
  );

  // Process events from agenda data - separate all-day and time events
  const { allDayEventsMap, timeEventsByDate } = useMemo(() => {
    const allDayMap = {};
    const timeMap = {};

    filteredAgendaFilter?.forEach((dateObj) => {
      const { requestedDate, officeSchedulerList } = dateObj;
      const dateKey = moment(requestedDate).format("MMM DD, ddd");

      if (!allDayMap[dateKey]) {
        allDayMap[dateKey] = {};
      }
      if (!timeMap[dateKey]) {
        timeMap[dateKey] =[];
      }

      officeSchedulerList?.forEach((scheduler) => {
        const allEvents = getAllStaffEvents(scheduler);
        const filteredEvents = filterEventsBySearch(
          allEvents,
          scheduler.user,
          searchValue,
        );
        const { allDayEvents, timeEvents } = categorizeEvents(filteredEvents);

        // Process all-day events
        allDayEvents.forEach((item) => {
          const userId = scheduler.user?.id;
          if (!allDayMap[dateKey][userId]) {
            allDayMap[dateKey][userId] =[];
          }

          // Use same color functions as hourly section for consistency
          const bgColor = getEventColor(item);
          // Get office color from officeColourCodes
          const dotColor = getOfficeColor(scheduler.user, selectedOwnerId);

          allDayMap[dateKey][userId].push({
            bgColor,
            dotColor,
            item,
            user: scheduler.user,
          });
        });

        // Process time-based events - store all events for the date (not grouped by hour)
        timeEvents.forEach((item) => {
          if (!item.startTime || !item.endTime) return;

          // Adjust event times to the requested date
          const startMoment = moment(item.startTime);
          const endMoment = moment(item.endTime);
          const requestedMoment = moment(requestedDate);

          startMoment.year(requestedMoment.year());
          startMoment.month(requestedMoment.month());
          startMoment.date(requestedMoment.date());

          endMoment.year(requestedMoment.year());
          endMoment.month(requestedMoment.month());
          endMoment.date(requestedMoment.date());

          // Use same color functions as hourly section for consistency
          const bgColor = getEventColor(item);
          // Get office color from officeColourCodes
          const dotColor = getOfficeColor(scheduler.user, selectedOwnerId);

          timeMap[dateKey].push({
            bgColor,
            dotColor,
            item: {
              ...item,
              startTime: startMoment.toISOString(),
              endTime: endMoment.toISOString(),
            },
            user: scheduler.user,
          });
        });
      });
    });

    return { allDayEventsMap: allDayMap, timeEventsByDate: timeMap };
  },[
    filteredAgendaFilter,
    searchValue,
    getAllStaffEvents,
    categorizeEvents,
    currentUserId,
    getEventColor,
    getEventBorderColor,
    t,
  ]);

  // Get event display text (time and office name) - similar to SchedulingTable
  const getEventDisplayText = useCallback(
    (event, user = null) => {
      if (!event) return null;

      const isAllDay =
        event.isAllDayEvent ||
        event.isAllDayBusy ||
        !event.startTime ||
        !event.endTime;

      if (!viewSettingFilter || viewSettingFilter.length === 0) {
        if (user) {
          const fullName =
            user.fullName ||
            (user.firstName && user.lastName
              ? `${user.firstName} ${user.lastName}`
              : user.firstName || "");
          if (fullName) {
            return (
              <div className="d-flex flex-column">
                <div className={styles["event-office"]}>{fullName}</div>
              </div>
            );
          }
        }
        return null;
      }

      let eventTitle = event?.title || "";

      const isLeaveRecord =
        event?.agendaType === constants.agendaType.LEAVE ||
        event?.type === "leave";

      // Match monthly / staff grid: show translated leave status when title filter (or any row text) is used
      if (isLeaveRecord) {
        const { text } = leaveClasses(event?.statusId);
        eventTitle = t(text);
      } else if (event?.agendaType === constants.agendaType.APPOINTMENT) {
        eventTitle = "Patient Appointment";
      } else if (event?.isShift) {
        const trimmed = eventTitle && String(eventTitle).trim();
        if (!trimmed) {
          eventTitle = t("scheduler.agenda.shiftTag");
        }
      }

      const officeName = renderOfficeNameOrEnterprise(event, t);

      let timeString = "";
      if (isAllDay) {
        timeString = "all-day";
      } else if (event?.startTime && event?.endTime) {
        const startTime = moment(event.startTime).format("h:mm a");
        const endTime = moment(event.endTime).format("h:mm a");
        timeString = `${startTime} - ${endTime}`;
      }

      const displayElements =[];

      if (viewSettingFilter.includes("title") && eventTitle) {
        displayElements.push(
          <div key="title" className={styles["event-office"]}>
            {eventTitle}
          </div>,
        );
      }

      if (
        viewSettingFilter.includes("officeName") &&
        canShowOfficeName &&
        officeName
      ) {
        displayElements.push(
          <div key="officeName" className={styles["event-office"]}>
            {officeName}
          </div>,
        );
      }

      if (viewSettingFilter.includes("timeString") && timeString) {
        displayElements.push(
          <div key="timeString" className={styles["event-office"]}>
            {timeString}
          </div>,
        );
      }

      const hasStaffMembers = viewSettingFilter.includes("staffMembers");
      const hasStaffFirstName = viewSettingFilter.includes("staffFirstName");

      if (hasStaffMembers && hasStaffFirstName && user) {
        const fullName =
          user.fullName ||
          (user.firstName && user.lastName
            ? `${user.firstName} ${user.lastName}`
            : user.firstName || "");
        if (fullName) {
          displayElements.push(
            <div key="staffMembers" className={styles["event-office"]}>
              {fullName}
            </div>,
          );
        }
      } else {
        if (hasStaffMembers && user) {
          const fullName =
            user.fullName ||
            (user.firstName && user.lastName
              ? `${user.firstName} ${user.lastName}`
              : user.firstName || "");
          if (fullName) {
            displayElements.push(
              <div key="staffMembers" className={styles["event-office"]}>
                {fullName}
              </div>,
            );
          }
        }

        if (hasStaffFirstName && user) {
          const firstName = user.firstName || "";
          if (firstName) {
            displayElements.push(
              <div key="staffFirstName" className={styles["event-office"]}>
                {firstName}
              </div>,
            );
          }
        }
      }

      if (displayElements.length === 0) {
        return null;
      }

      return <div className="d-flex flex-column">{displayElements}</div>;
    },[t, viewSettingFilter, canShowOfficeName],
  );

  // Helper functions for time-based event positioning (from SchedulingTable)
  const getTimeInMinutes = useCallback((time) => {
    if (!time) {
      return 0;
    }
    const date = new Date(time);
    if (isNaN(date.getTime())) {
      return 0;
    }
    const hours = date.getHours();
    const minutes = date.getMinutes();
    return hours * 60 + minutes;
  },[]);

  const calculateOverlapPositions = useCallback(
    (events) => {
      events.sort(
        (a, b) => getTimeInMinutes(a.startTime) - getTimeInMinutes(b.startTime),
      );

      const positions =[];

      for (let i = 0; i < events.length; i++) {
        let overlaps = [events[i]];
        for (let j = i + 1; j < events.length; j++) {
          const endA = getTimeInMinutes(events[i].endTime);
          const startB = getTimeInMinutes(events[j].startTime);

          if (startB < endA) {
            overlaps.push(events[j]);
          }
        }

        const totalOverlap = overlaps.length;
        overlaps.forEach((event, index) => {
          positions.push({
            event,
            widthFactor: 1 / totalOverlap,
            leftOffsetFactor: index / totalOverlap,
          });
        });

        i += overlaps.length - 1;
      }

      return positions;
    },
    [getTimeInMinutes],
  );

  const groupEventsByStartTime = useCallback(
    (events) => {
      const grouped = {};
      events.forEach((event) => {
        const startMinutes = getTimeInMinutes(event.startTime);
        if (!grouped[startMinutes]) {
          grouped[startMinutes] = [];
        }
        grouped[startMinutes].push(event);
      });
      return grouped;
    },
    [getTimeInMinutes],
  );

  const goToDetails = useCallback(
    (id, type, createdByMe, requestedDate) => {
      if (!id || !type) return;
      const locationStateSending = {
        requestedDate,
        fromScreen: isSchedulingAssistant
          ? "schedulingAssistant"
          : "staffSchedule",
        schedulingAssistantState: {
          selectedStaff,
          currentDate,
        },
        eventId: eventIdFromUrl,
      };
      switch (type) {
        case constants.agendaType.EVENT: {
          let pathname = "/";
          pathname = createdByMe
            ? constants.routes.scheduler.eventDetails.replace(
                ":eventId",
                encodeId(id),
              )
            : constants.routes.scheduler.eventDetailsOnly.replace(
                ":eventId",
                encodeId(id),
              );
          history.replace({
            state: locationStateSending,
            search:window.location.search,
          });

          history.push({
            pathname,
            state: locationStateSending,
            search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
          });
          break;
        }
        case constants.agendaType.BUSY_SLOT: {
          const pathname = constants.routes.scheduler.busySlotDetail.replace(
            ":busySlotId",
            encodeId(id),
          );
          history.replace({
            state: locationStateSending,
            search:window.location.search,
          });
          history.push({
            pathname,
            state: locationStateSending,
            search: effectiveOwnerIdString ? `?${effectiveOwnerIdString}` : "",
          });
          break;
        }
        default: {
          return;
        }
      }
    },
    [history, selectedStaff, currentDate, effectiveOwnerIdString],
  );

  // Get popup data (similar to StaffAvailabilityWeeklyView)
  const getPopupData = useCallback(
    (item, requestedDate) => {
      const data = {};
      data.title = item?.title || item?.reasonForBlock || null;
      data.officeName = renderOfficeNameOrEnterprise(item, t);
      data.patientFullName = item?.patientFullName || null;
      data.startTime = moment(item?.startTime).format("h:mm a");
      data.endTime = moment(item?.endTime).format("h:mm a");
      data.date = moment(requestedDate).format("MMM D, YYYY [-] ddd");
      const { agendaType } = item;
      switch (agendaType) {
        case constants.agendaType.EVENT: {
          const createdByOthers =
            item?.isShift && profile?.id !== item?.createdById;
          if (createdByOthers) {
            data.tag = t("scheduler.agenda.shiftByOthers");
          } else if (item?.isShift) {
            data.tag = t("scheduler.agenda.shiftTag");
          } else {
            data.tag = t("scheduler.agenda.eventTag");
          }
          break;
        }
        case constants.agendaType.BUSY_SLOT: {
          data.tag = t("scheduler.agenda.busyTag");
          break;
        }
        case constants.agendaType.BLOCKED: {
          data.tag = t("scheduler.agenda.busyTag");
          break;
        }
        case constants.agendaType.APPOINTMENT: {
          data.tag = t("scheduler.agenda.appointmentTag");
          data.title = t("scheduler.agenda.patient", {
            name: item.patientFullName,
          });
          data.isAppointment = true;
          const status = findKey(
            constants.appointmentStatus,
            (s) => s === item.appointmentStatus,
          );
          data.appointmentStatus = status
            ? t(`appointmentStatus.${status}`)
            : "--";
          break;
        }
        case constants.agendaType.LEAVE: {
          const { text } = leaveClasses(item?.statusId);
          data.tag = t(text);
          data.title = "";
          data.isLeave = true;
          break;
        }
        default: {
          break;
        }
      }
      return data;
    },
    [t, profile?.id],
  );

  const popUpRef = useRef(null);

  // Get popup view (similar to StaffAvailabilityWeeklyView)
  const getPopupView = useCallback(
    (item, backgroudColor, tagBackgroundColor, requestedDate, staffName) => {
      const data = getPopupData(item, requestedDate);

      return (
        <div
          className={schedulerStyles["scheduler-popup-box"]}
          // ref={popUpRef}
          style={{ background: "#ffffff" }}
        >
          <span
            className={schedulerStyles["close-icon"]}
            onClick={resetHoverKey}
          >
            &times;
          </span>
          <div
            className={
              schedulerStyles["scheduler-event-box"] +
              (backgroudColor ? " " + schedulerStyles[backgroudColor] : "")
            }
          >
            <div
              className={
                schedulerStyles["event-tag"] +
                " " +
                schedulerStyles[tagBackgroundColor]
              }
            >
              {data.tag}
            </div>
            <div className={schedulerStyles["event-type"]}>{data.title}</div>
            <Row className={schedulerStyles.row}>
              <Col sm="6">
                <Text
                  size="10px"
                  marginBottom="0px"
                  weight="400"
                  color="#87928D"
                >
                  {constants.agendaType.APPOINTMENT === item.agendaType
                    ? t("scheduler.agenda.doctorName")
                    : t("scheduler.agenda.staffName")}
                </Text>
                <Text
                  size="12px"
                  marginBottom="10px"
                  weight="500"
                  color="#2F3245"
                >
                  {staffName}
                </Text>
              </Col>
              <Col sm="6">
                <Text
                  size="10px"
                  marginBottom="0px"
                  weight="400"
                  color="#87928D"
                >
                  {t("accountOwner.officeName")}
                </Text>
                <Text
                  size="12px"
                  marginBottom="10px"
                  weight="500"
                  color="#2F3245"
                >
                  {data.officeName}
                </Text>
              </Col>
              <Col sm="6">
                <Text
                  size="10px"
                  marginBottom="0px"
                  weight="400"
                  color="#87928D"
                >
                  {t("accountOwner.date")}
                </Text>
                <Text
                  size="12px"
                  marginBottom="10px"
                  weight="500"
                  color="#2F3245"
                >
                  {data.date}
                </Text>
              </Col>
              {!data.isLeave && (
                <Col sm="6">
                  <Text
                    size="10px"
                    marginBottom="0px"
                    weight="400"
                    color="#87928D"
                  >
                    {data.isAppointment
                      ? t("timeOfAppointment")
                      : t("staff.startTime")}
                  </Text>
                  <Text
                    size="12px"
                    marginBottom="12px"
                    weight="500"
                    color="#2F3245"
                  >
                    {data.startTime}
                  </Text>
                </Col>
              )}
              {!data.isLeave && (
                <Col sm="6">
                  <Text
                    size="10px"
                    marginBottom="0px"
                    weight="400"
                    color="#87928D"
                  >
                    {data.isAppointment ? t("status") : t("staff.endTime")}
                  </Text>
                  <Text
                    size="12px"
                    marginBottom="12px"
                    weight="500"
                    color="#2F3245"
                  >
                    {data.isAppointment
                      ? data?.appointmentStatus
                      : data.endTime}
                  </Text>
                </Col>
              )}
            </Row>
          </div>
        </div>
      );
    },
    [getPopupData, t, resetHoverKey],
  );

  // Check if event can be dragged
  const canDragEvent = useCallback(
    (eventItem) => {
      const createdByMe = eventItem.createdById === currentUserId;
      const isBusySlot =
        eventItem.agendaType === constants.agendaType.BUSY_SLOT;
      const isBlocked = eventItem.agendaType === constants.agendaType.BLOCKED;

      // Can drag if:
      // 1. Events and busy slots: Only if created by logged-in user
      // 2. Shifts: Can be moved by creator OR by owner/admin (if user has admin permission for that office)

      // Check for busy slots and blocked first
      if (isBusySlot || isBlocked) {
        return createdByMe;
      }

      // IMPORTANT: Check for shifts BEFORE checking for regular events
      // because shifts have agendaType === EVENT but also have isShift === true
      if (eventItem?.isShift) {
        // If created by me, always allow
        if (createdByMe) {
          return true;
        }
        // If created by others, check if user is owner or admin for that office
        const createdByOthers = eventItem.createdById !== currentUserId;
        if (createdByOthers) {
          // Owner can always move shifts
          if (isOwner) {
            return true;
          }
          // Admin can move shifts in offices where they have admin permission
          if (isStaff && canEditAndViewOthersData(eventItem?.officeId)) {
            return true;
          }
        }
        return false;
      }

      // Regular events (non-shifts) can only be moved by creator
      if (eventItem.agendaType === constants.agendaType.EVENT) {
        return createdByMe;
      }

      return false;
    },
    [currentUserId, isOwner, isStaff, canEditAndViewOthersData],
  );

  // Helper function to get time range from hours array (view's time range)
  // The time range is always based on the hours displayed in the view (12 AM to 11:59 PM)
  const getTimeRange = useCallback(() => {
    // Use hours array to determine range (00:00 to 23:59)
    const minHour = hours.length > 0 ? hours[0].hour : 0;
    const maxHour = hours.length > 0 ? hours[hours.length - 1].hour : 23;
    return {
      startTime: moment().hour(minHour).minute(0).second(0),
      endTime: moment().hour(maxHour).minute(59).second(59),
    };
  }, [hours]);

  // Helper function to check if time is within allowed range
  // Checks both that the time is within the range AND on the same day
  const isTimeWithinRange = useCallback((timeMoment, timeRange, baseDate) => {
    if (!timeMoment || !timeRange) return true;

    // Check if time is on the same day as baseDate
    if (baseDate && !timeMoment.isSame(baseDate, "day")) {
      return false;
    }

    const timeInMinutes = timeMoment.hour() * 60 + timeMoment.minute();
    const rangeStartMinutes =
      timeRange.startTime.hour() * 60 + timeRange.startTime.minute();
    const rangeEndMinutes =
      timeRange.endTime.hour() * 60 + timeRange.endTime.minute();

    return (
      timeInMinutes >= rangeStartMinutes && timeInMinutes <= rangeEndMinutes
    );
  },[]);

  // Calculate new date and time from drop position with 15-minute snap
  const calculateNewDateTime = useCallback(
    (eventItem, dropX, dropY, cellElement, dayIndex, hourIndex) => {
      if (
        !cellElement ||
        dayIndex < 0 ||
        dayIndex >= weekData.length ||
        !eventItem
      ) {
        return null;
      }
      const cellRect = cellElement.getBoundingClientRect();
      const relativeY = dropY - cellRect.top;
      const cellHeight = cellRect.height; // Height of hour cell (60px)
      const minuteHeight = cellHeight / 60; // Each minute takes this much height
      const minutesFromHourStart = relativeY / minuteHeight;
      const snappedMinutes = Math.round(minutesFromHourStart / 15) * 15;
      const clampedMinute = Math.max(0, Math.min(45, snappedMinutes));

      // Get the target date
      const targetDate = weekData[dayIndex];
      if (!targetDate) return null;

      const newDate = moment(targetDate.date);
      const newStartTime = moment(newDate)
        .hour(hourIndex)
        .minute(clampedMinute)
        .second(0);

      // Get time range for validation (view's time range: 12 AM to 11:59 PM)
      const timeRange = getTimeRange();

      // Calculate duration from original event
      if (!eventItem.startTime || !eventItem.endTime) {
        // Default to 1 hour if no duration available
        const durationMinutes = 60;
        const newEndTime = moment(newStartTime).add(durationMinutes, "minutes");

        // Check if new times are within allowed range (both start and end must be within range and on same day)
        if (
          !isTimeWithinRange(newStartTime, timeRange, newDate) ||
          !isTimeWithinRange(newEndTime, timeRange, newDate)
        ) {
          return { error: "timeRangeExceeded" };
        }
        return {
          newDate: newDate.toDate(),
          newStartTime: newStartTime.toDate(),
          newEndTime: newEndTime.toDate(),
          newStartTimeString: newStartTime.format("YYYY-MM-DDTHH:mm"),
          newEndTimeString: newEndTime.format("YYYY-MM-DDTHH:mm"),
        };
      }

      const originalStart = moment(eventItem.startTime);
      const originalEnd = moment(eventItem.endTime);
      const durationMinutes = originalEnd.diff(originalStart, "minutes");

      const newEndTime = moment(newStartTime).add(durationMinutes, "minutes");

      // Check if new times are within allowed range (both start and end must be within range and on same day)
      if (
        !isTimeWithinRange(newStartTime, timeRange, newDate) ||
        !isTimeWithinRange(newEndTime, timeRange, newDate)
      ) {
        return { error: "timeRangeExceeded" };
      }

      return {
        newDate: newDate.toDate(),
        newStartTime: newStartTime.toDate(),
        newEndTime: newEndTime.toDate(),
        newStartTimeString: newStartTime.format("YYYY-MM-DDTHH:mm"),
        newEndTimeString: newEndTime.format("YYYY-MM-DDTHH:mm"),
      };
    },[weekData, getTimeRange, isTimeWithinRange],
  );

  // Helper to check if time changed (similar to EditEvent)
  const getTimeCheck = useCallback((alreadyTime, selectedTime) => {
    if (alreadyTime) {
      const selectedStartTime = moment(selectedTime);
      const alreadySelectedStartTime = moment(alreadyTime);
      if (
        selectedStartTime.hour() !== alreadySelectedStartTime.hour() ||
        selectedStartTime.minute() !== alreadySelectedStartTime.minute()
      ) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  },[]);

  // Internal function to perform the actual update (called directly or from modal)
  const performEventUpdate = useCallback(
    async (eventData, newDateTime, editType, originalRequestedDate = null) => {
      if (!newDateTime || !eventData) {
        toast.error(t("scheduler.invalidEventData"));
        return;
      }

      // Check what changed (similar to EditEvent verifyIfUpdated)
      // Use matchedBothDatesValues for consistency with EditEvent
      // This correctly determines if the date changed, accounting for recurring events
      const requestedDateForCheck = originalRequestedDate
        ? originalRequestedDate
        : eventData.requestedDate
          ? moment(eventData.requestedDate).format("YYYY-MM-DD")
          : eventData.startTime
            ? moment(eventData.startTime).format("YYYY-MM-DD")
            : moment(eventData.date || newDateTime.newDate).format(
                "YYYY-MM-DD",
              );

      const dateChangedResult = matchedBothDatesValues({
        eventDetail: eventData,
        repeatedEndDate: eventData.repeatedEndDate
          ? moment(eventData.repeatedEndDate).toDate()
          : moment().add(3, "month").toDate(),
        requestedDate: requestedDateForCheck,
        eventDate: newDateTime.newDate,
      });

      // Validate repeatedEndDate: if new date is after repeatedEndDate, show error
      const neverCheck =
        eventData.repeatedType ===
        addEditEventsConst.repeatedOptionsValues.never;
      if (!neverCheck && eventData.repeatedEndDate) {
        const newDateStr = moment(newDateTime.newDate).format("YYYY-MM-DD");
        const repeatedEndDateStr = moment(eventData.repeatedEndDate).format(
          "YYYY-MM-DD",
        );
        // Check if new date is NOT before repeatedEndDate and they're not equal
        if (
          !moment(newDateStr).isBefore(repeatedEndDateStr) &&
          newDateStr !== repeatedEndDateStr
        ) {
          toast.error(t("form.errors.endGreater"));
          return;
        }
      }

      const startTimeChanged = getTimeCheck(
        eventData.startTime,
        newDateTime.newStartTimeString,
      );
      const endTimeChanged = getTimeCheck(
        eventData.endTime,
        newDateTime.newEndTimeString,
      );

      // Get the original requested date (the date of the instance being edited)
      // This should be the original date, not the new date (same as EditEvent)
      const originalRequestedDateForParams = originalRequestedDate
        ? moment(originalRequestedDate).format("YYYY-MM-DDTHH:mm")
        : eventData.requestedDate
          ? moment(eventData.requestedDate).format("YYYY-MM-DDTHH:mm")
          : eventData.startTime
            ? moment(eventData.startTime).format("YYYY-MM-DDTHH:mm")
            : moment(newDateTime.newDate).format("YYYY-MM-DDTHH:mm");

      // Get requestedDate for Date calculation (same as EditEvent line 193)
      // This is the date of the instance being edited
      const requestedDateForDateCalc = originalRequestedDate
        ? moment(originalRequestedDate).toDate()
        : eventData.requestedDate
          ? moment(eventData.requestedDate).toDate()
          : eventData.startTime
            ? moment(eventData.startTime).toDate()
            : null;

      // Get eventDate (the new date where we're dropping)
      const eventDate = moment(newDateTime.newDate).toDate();

      // Calculate Date parameter using EXACT same logic as EditEvent (lines 794-801)
      const params = {
        SchedulerEventId: eventData.id,
        OwnerId: selectedOwnerId || currentUserId,
        Title: eventData.title,
        Date: moment(
          requestedDateForDateCalc &&
            moment(requestedDateForDateCalc)
              .startOf("day")
              .isSame(moment(eventDate).startOf("day"))
            ? eventData?.date
            : eventDate,
        ).format("YYYY-MM-DDTHH:mm"),
        StartTime: newDateTime.newStartTimeString,
        EndTime: newDateTime.newEndTimeString,
        IsAllDayEvent: eventData.isAllDayEvent || false,
        RepeatedType: eventData.repeatedType || 1,
        RepeatedDay: moment(newDateTime.newDate).isoWeekday(),
        RepeatedEndDate:
          eventData.repeatedType > 1 && eventData.repeatedEndDate
            ? moment(eventData.repeatedEndDate).format("YYYY-MM-DD")
            : null,
        Location: eventData.location || "",
        BlockForPatient: eventData.blockForPatient || false,
        Note: eventData.note || "",
        PublishAsEvent: eventData.publishAsEvent || false,
        eventEmployees: Array.isArray(eventData.eventEmployees)
          ? eventData.eventEmployees
          :[],
        EventRoles: Array.isArray(eventData.eventRoles)
          ? eventData.eventRoles
          :[],
        EventTags: Array.isArray(eventData.eventTags)
          ? eventData.eventTags
          :[],
        CreatedAt: moment().format("YYYY-MM-DDTHH:mm"),
        ReminderBeforeInMins: eventData.reminderBeforeInMins || 0,
        isDraft: eventData.isDraft || false,
        requestedDate: originalRequestedDateForParams,
        timezoneCode: eventData.timezoneCode || moment.tz.guess(),
        EditType: editType || editTypesVariables.allEvent,
        UpdateFlags: {
          isTitleEdit: false,
          isStartTimeEdit: startTimeChanged,
          isEndTimeEdit: endTimeChanged,
          isAllDayEventEdit: false,
          isNoteEdit: false,
          isLocationEdit: false,
          isReminderBeforeInMinsEdit: false,
          isEnterpriseEdit: false,
          isOfficeIdEdit: false,
          EmployeeIds: [],
          RoleIds:[],
          IsRepeatTypeChange: false,
          IsEventDateChange: dateChangedResult.startDateChanged,
          IsRepeatedEndDateChange: dateChangedResult.endDateChanged,
          IsBlockForPatientChange: false,
          tagsIds: false,
        },
      };

      if (eventData.isShift) {
        params.Title = eventData.title || "";
        delete params.Location;
        delete params.Note;
        if (
          Array.isArray(eventData.eventEmployees) &&
          eventData.eventEmployees.length > 0 &&
          eventData.eventEmployees[0]
        ) {
          params.officeId = eventData.eventEmployees[0].officeId || null;
        }
      } else {
        params.IsAutoApprove = eventData.isAutoApprove || false;
      }

      // Use setterCustomSchduler to handle custom repeat patterns (similar to EditEvent)
      try {
        setterCustomSchduler({
          params,
          repeatedType: eventData.repeatedType || 1,
          repeatedTypeFrequency: eventData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: eventData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedSlotDate:
            eventData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||[],
          selectedWeek: eventData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedMonths:
            eventData.customRepeatPattern?.monthsOfYear?.map((m) => m?.month) ||[],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: eventData,
        });
      } catch (error) {
        console.warn("Error in setterCustomSchduler:", error);
        // Continue with update even if setterCustomSchduler fails
      }

      // Use setterPublishOffices to handle publish settings (similar to EditEvent)
      try {
        const preferredOption = {
          dropdown: eventData.publishAsEvent
            ? [{ id: "allowInvitees" }]
            : eventData.isDraft
              ? [{ id: "saveDraft" }]
              : [{ id: "inviteesOnly" }],
          otherOptions:[],
        };
        setterPublishOffices({
          preferredOption,
          userIds: Array.isArray(eventData.eventEmployees)
            ? eventData.eventEmployees
            :[],
          publishAsEvent: eventData.publishAsEvent
            ? "allowInvitees"
            : eventData.isDraft
              ? "saveDraft"
              : "inviteesOnly",
          nonInviteesPublish: eventData.publishedType || "allOffices",
          params,
          officeIdForNonInvitee: Array.isArray(
            eventData.schedulerEventPublishedOffices,
          )
            ? eventData.schedulerEventPublishedOffices.filter(
                (office) => office && office.id,
              )
            :[],
          edit: true,
          isDraft: eventData.isDraft || false,
        });
      } catch (error) {
        console.warn("Error in setterPublishOffices:", error);
        // Continue with update even if setterPublishOffices fails
      }

      await createSchedulerEventMutation.mutateAsync(params);

      // Invalidate query cache to refresh data
      queryClient.invalidateQueries(["office_agenda"]);

      toast.success(t("staff.eventUpdated"));
    },[
      selectedOwnerId,
      currentUserId,
      createSchedulerEventMutation,
      t,
      queryClient,
      getTimeCheck,
    ],
  );

  // Update event/shift via API (with EditEvent-style checks and modal)
  const updateEventAfterDrag = useCallback(
    async (eventItem, newDateTime, editType = null) => {
      if (!newDateTime || !eventItem || !eventItem.id) {
        toast.error(t("scheduler.invalidEventData"));
        return;
      }

      try {
        // Fetch current event details to get all required fields
        // Use the original requestedDate from the event if available, otherwise use new date
        const originalRequestedDate = draggedEventDateRef.current
          ? draggedEventDateRef.current?.format("YYYY-MM-DD")
          : moment(eventItem.startTime || newDateTime.newDate).format(
              "YYYY-MM-DD",
            );

        const eventDetails = await getEventListDetails(
          eventItem.id,
          originalRequestedDate,
        );
        const eventData = eventDetails?.data;

        if (!eventData) {
          toast.error(t("scheduler.eventNotFound"));
          return;
        }

        // Check what changed (similar to EditEvent verifyIfUpdated)
        // Calculate dateChanged using matchedBothDatesValues (same as EditEvent)
        const dateChangedResult = matchedBothDatesValues({
          eventDetail: eventData,
          repeatedEndDate: eventData.repeatedEndDate
            ? moment(eventData.repeatedEndDate).toDate()
            : moment().add(3, "month").toDate(),
          requestedDate: originalRequestedDate,
          eventDate: newDateTime.newDate,
        });

        // Calculate repeatedOptionChanged (should be false for drag-drop as we're not changing pattern)
        const repeatedOptionChanged = matchedBothPatternValues({
          repeatedType: eventData.repeatedType || 1,
          repeatedTypeFrequency: eventData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: eventData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedSlotDate:
            eventData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||[],
          selectedWeek: eventData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            eventData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedMonths:
            eventData.customRepeatPattern?.monthsOfYear?.map((m) => m?.month) ||[],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: eventData,
        });

        // Calculate anyChangedForDate (same as EditEvent)
        const anyChangedForDate =        repeatedOptionChanged;

        const startTimeChanged = getTimeCheck(
          eventData.startTime,
          newDateTime.newStartTimeString,
        );
        const endTimeChanged = getTimeCheck(
          eventData.endTime,
          newDateTime.newEndTimeString,
        );

        const hasChanges =
          dateChangedResult.startDateChanged ||
          dateChangedResult.endDateChanged ||
          startTimeChanged ||
          endTimeChanged;

        // Validate repeatedEndDate: if new date is after repeatedEndDate, show error
        const neverCheck =
          eventData.repeatedType ===
          addEditEventsConst.repeatedOptionsValues.never;
        if (!neverCheck && eventData.repeatedEndDate) {
          const newDateStr = moment(newDateTime.newDate).format("YYYY-MM-DD");
          const repeatedEndDateStr = moment(eventData.repeatedEndDate).format(
            "YYYY-MM-DD",
          );
          // Check if new date is NOT before repeatedEndDate and they're not equal
          if (
            !moment(newDateStr).isBefore(repeatedEndDateStr) &&
            newDateStr !== repeatedEndDateStr
          ) {
            toast.error(t("form.errors.endGreater"));
            return;
          }
        }

        // Check if event is repeating (similar to EditEvent logic)
        const isNotDrafted = !eventData.isDraft;

        // If event is repeating, has changes, is not a draft, and no editType provided, show modal
        if (!neverCheck && !editType && hasChanges && isNotDrafted) {
          // Store update parameters for modal confirmation
          setPendingDragUpdate({
            eventData,
            newDateTime,
            anyChangedForDate,
            originalRequestedDate,
          });
          setEditModalConfirmation(true);
          return;
        }

        // Perform the update - pass originalRequestedDate for correct date change detection
        await performEventUpdate(
          eventData,
          newDateTime,
          editTypesVariables.allEvent,
          originalRequestedDate,
        );
      } catch (error) {
        toast.error(error.message || t("scheduler.updateFailed"));
        throw error;
      }
    },
    [t, getTimeCheck, performEventUpdate, draggedEvent],
  );

  // Internal function to perform the actual busy slot update (called directly or from modal)
  const performBusySlotUpdate = useCallback(
    async (
      busySlotData,
      newDateTime,
      editType,
      officeDetails,
      officeIds,
      busySlotEmployeeView,
      isAllDayBusy,
      repeatedType,
      repeatedEndDate,
      originalRequestedDate,
      UpdateFlags,
    ) => {
      if (!newDateTime || !busySlotData) {
        toast.error(t("scheduler.invalidEventData"));
        return;
      }

      // Format dates and times
      const eventDateMoment = moment(newDateTime.newDate);
      const startTime = moment(newDateTime.newStartTime);
      const endTime = moment(newDateTime.newEndTime);

      // Get requestedDate for Date calculation (same as EditEvent line 193)
      // This is the date of the instance being edited
      const requestedDateForDateCalc = originalRequestedDate
        ? moment(originalRequestedDate).toDate()
        : busySlotData.requestedDate
          ? moment(busySlotData.requestedDate).toDate()
          : busySlotData.startTime
            ? moment(busySlotData.startTime).toDate()
            : null;

      // Get eventDate (the new date where we're dropping)
      const eventDate = eventDateMoment.toDate();

      // Helper function to format time like AddBusySlots startOrEndTimeValue
      const formatBusySlotTime = (timeValue, startOrEnd) => {
        if (isAllDayBusy) {
          return moment(eventDateMoment)
            [startOrEnd]("day")
            .format("YYYY-MM-DDTHH:mm");
        }
        if (!timeValue) {
          return null;
        }
        return (
          moment(eventDateMoment).format("YYYY-MM-DDT") +
          moment(timeValue).format("HH:mm")
        );
      };

      // Build params exactly like AddBusySlots
      // Calculate Date parameter using EXACT same logic as EditEvent (lines 794-801)
      const params = {
        OwnerId: officeDetails.ownerId,
        OfficeIds: officeIds,
        Title: busySlotData.title || "",
        Date: moment(
          requestedDateForDateCalc &&
            moment(requestedDateForDateCalc)
              .startOf("day")
              .isSame(moment(eventDate).startOf("day"))
            ? busySlotData?.date
            : eventDate,
        ).format("YYYY-MM-DDTHH:mm"),
        StartTime: formatBusySlotTime(startTime, "startOf"),
        EndTime: formatBusySlotTime(endTime, "endOf"),
        repeatedType: +repeatedType,
        CreatedAt: moment().format("YYYY-MM-DDTHH:mm"),
        repeatedDay: +repeatedType === 1 ? null : eventDateMoment.isoWeekday(),
        RepeatedEndDate:
          +repeatedType === 1
            ? null
            : moment(repeatedEndDate).format("YYYY-MM-DD"),
        Location: busySlotData.location || "",
        Description: busySlotData.description || "",
        IsNotifyEmployee: busySlotData.isNotifyEmployee || false,
        BusySlotEmployeeView: busySlotEmployeeView,
        IsAllDayBusy: isAllDayBusy,
      };

      // Call setterCustomSchduler to handle custom repeat patterns
      try {
        setterCustomSchduler({
          params,
          repeatedType: repeatedType,
          repeatedTypeFrequency: busySlotData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: busySlotData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            busySlotData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedSlotDate:
            busySlotData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||[],
          selectedWeek: busySlotData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            busySlotData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedMonths:
            busySlotData.customRepeatPattern?.monthsOfYear?.map(
              (m) => m?.month,
            ) ||[],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: busySlotData,
        });
      } catch (error) {
        console.warn("Error in setterCustomSchduler:", error);
      }

      // Add edit-specific fields
      params.UpdateFlags = UpdateFlags;
      params.EditType = editType || 3;
      params.SchedulerBusySlotId = busySlotData.id;
      params.RequestedDate = originalRequestedDate;
      // Delete isRepeated when editing (as per AddBusySlots)
      delete params.isRepeated;

      await updateBusySlot(params);

      // Invalidate query cache to refresh data
      queryClient.invalidateQueries(["office_agenda"]);

      toast.success(t("scheduler.busySlotUpdated"));
    },[t, queryClient],
  );

  // Update busy slot via API (matching EditBusySlot handleBlock logic)
  const updateBusySlotAfterDrag = useCallback(
    async (eventItem, newDateTime) => {
      if (!newDateTime || !eventItem || !eventItem.id) {
        toast.error(t("scheduler.invalidEventData"));
        return;
      }

      try {
        // Fetch current busy slot details to get all required fields (like updateEventAfterDrag)
        // Use the original requestedDate from the event if available, otherwise use new date
        const originalRequestedDate = draggedEventDateRef.current
          ? draggedEventDateRef.current?.format("YYYY-MM-DD")
          : moment(
              eventItem.startTime || eventItem.date || newDateTime.newDate,
            ).format("YYYY-MM-DD");

        let busySlotDetails = null;
        try {
          busySlotDetails = await getBusySlot({
            queryKey:[
              "busy-slot-details",
              eventItem.id,
              originalRequestedDate,
            ],
          });
        } catch (error) {
          toast.error(error.message || t("scheduler.updateFailed"));
          return;
        }

        const busySlotData = busySlotDetails?.data;

        if (!busySlotData) {
          toast.error(t("scheduler.eventNotFound"));
          return;
        }

        // Fetch office details to get correct ownerId and officeId (like EditBusySlot)
        const officeId = busySlotData.officeId || eventItem.officeId;
        if (!officeId) {
          toast.error(t("scheduler.officeIdRequired"));
          return;
        }

        let officeDetails = null;
        try {
          officeDetails = await getOfficeDetail(officeId);
        } catch (error) {
          toast.error(
            error.message || t("scheduler.failedToFetchOfficeDetails"),
          );
          return;
        }

        if (!officeDetails) {
          toast.error(t("scheduler.officeDetailsNotFound"));
          return;
        }

        // Determine if it's all-day event
        const isAllDayBusy =
          eventItem.isAllDayBusy ||
          eventItem.isAllDayEvent ||
          !eventItem.startTime ||
          !eventItem.endTime;

        // Format dates and times exactly like AddBusySlots
        const eventDate = moment(newDateTime.newDate);
        const startTime = moment(newDateTime.newStartTime);
        const endTime = moment(newDateTime.newEndTime);

        const repeatedType = +(busySlotData.repeatedType || 1);
        const repeatedEndDate = busySlotData.repeatedEndDate
          ? moment(busySlotData.repeatedEndDate)
          : moment().toDate();

        // Helper function to format time like AddBusySlots startOrEndTimeValue
        const formatBusySlotTime = (timeValue, startOrEnd) => {
          if (isAllDayBusy) {
            return moment(eventDate)
              [startOrEnd]("day")
              .format("YYYY-MM-DDTHH:mm");
          }
          if (!timeValue) {
            return null;
          }
          return (
            moment(eventDate).format("YYYY-MM-DDT") +
            moment(timeValue).format("HH:mm")
          );
        };

        // Build OfficeIds array - if schedulerBusySlotOffice exists, use it, otherwise create new
        let officeIds =[];
        if (
          busySlotData.schedulerBusySlotOffice &&
          Array.isArray(busySlotData.schedulerBusySlotOffice)
        ) {
          officeIds = busySlotData.schedulerBusySlotOffice.map((ele) => ({
            id: ele.externalId || ele.id || 0,
            SchedulerBusySlotId: busySlotData.id,
            OfficeId: ele.officeId,
            IsDeleted: false,
          }));
        } else {
          // If no schedulerBusySlotOffice, create from officeId
          officeIds =[
            {
              id: 0,
              SchedulerBusySlotId: busySlotData.id,
              OfficeId: officeId,
              IsDeleted: false,
            },
          ];
        }

        // Build BusySlotEmployeeView
        const busySlotEmployeeView = (
          busySlotData.busySlotNotifiedUsers ||
          eventItem.busySlotNotifiedUsers ||[]
        ).map((item) => ({
          userid: item.userId,
          OfficeId: item.officeId || officeId,
        }));

        // Calculate dateChanged using matchedBothDatesValues (same as AddBusySlots)
        const dateChangedResult = matchedBothDatesValues({
          eventDetail: busySlotData,
          repeatedEndDate: repeatedEndDate,
          requestedDate: originalRequestedDate,
          eventDate: eventDate.toDate(),
        });

        // Calculate repeatedOptionChanged using matchedBothPatternValues (same as AddBusySlots)
        const repeatedOptionChanged = matchedBothPatternValues({
          repeatedType: repeatedType,
          repeatedTypeFrequency: busySlotData.customRepeatPattern?.unit || 1,
          repeatedTypeEvery: busySlotData.customRepeatPattern?.interval || 1,
          selectionType: true,
          schedule:
            busySlotData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedSlotDate:
            busySlotData.customRepeatPattern?.daysOfMonth?.map((d) => d?.day) ||[],
          selectedWeek: busySlotData.customRepeatPattern?.monthWeekNumber || 1,
          selectedDay:
            busySlotData.customRepeatPattern?.daysOfWeek?.map(
              (d) => d?.dayOfWeek,
            ) ||[],
          selectedMonths:
            busySlotData.customRepeatPattern?.monthsOfYear?.map(
              (m) => m?.month,
            ) ||[],
          isDaySwitchOn: false,
          edit: true,
          eventDetail: busySlotData,
        });

        // Calculate anyChangedForDate (same as AddBusySlots)
        const anyChangedForDate =          repeatedOptionChanged;

        // Validate repeatedEndDate: if new date is after repeatedEndDate, show error
        const neverCheck =
          repeatedType === addEditEventsConst.repeatedOptionsValues.never;
        if (!neverCheck && busySlotData.repeatedEndDate) {
          const newDateStr = moment(eventDate).format("YYYY-MM-DD");
          const repeatedEndDateStr = moment(
            busySlotData.repeatedEndDate,
          ).format("YYYY-MM-DD");
          // Check if new date is NOT before repeatedEndDate and they're not equal
          if (
            !moment(newDateStr).isBefore(repeatedEndDateStr) &&
            newDateStr !== repeatedEndDateStr
          ) {
            toast.error(t("form.errors.endGreater"));
            return;
          }
        }

        // Build UpdateFlags (same as AddBusySlots verifyIfUpdated)
        const UpdateFlags = {
          isTitleEdit: false,
          isStartTimeEdit: getTimeCheck(
            busySlotData.startTime,
            formatBusySlotTime(startTime, "startOf"),
          ),
          isEndTimeEdit: getTimeCheck(
            busySlotData.endTime,
            formatBusySlotTime(endTime, "endOf"),
          ),
          IsAllDayBusyEdit: busySlotData.isAllDayBusy !== isAllDayBusy,
          isLocationEdit: false,
          IsDescriptionEdit: false,
          IsOfficeEdit: false,
          IsNotifiedUserEdit: false,
          IsNotifiedStaffListEdit: false,
          IsRepeatTypeChange: repeatedOptionChanged,
          IsBusySlotDateChange: dateChangedResult.startDateChanged,
          IsRepeatedEndDateChange: dateChangedResult.endDateChanged,
          OfficeIds: [],
          BusySlotEmployeeView:[],
        };

        // Check if there are any changes (similar to AddBusySlots verifyIfUpdated)
        const verified = {
          UpdateFlags,
          changedCheck: Object.values(UpdateFlags || {})?.some((value) =>
            typeof value === "boolean" ? value : value?.length > 0,
          ),
        };

        // Check if we need to show the modal (same logic as AddBusySlots handleBlock)
        // If busy slot is repeating, has changes, and no editType provided, show modal
        if (!neverCheck && (verified.changedCheck || anyChangedForDate)) {
          // Store update parameters for modal confirmation
          setPendingDragUpdate({
            busySlotData,
            newDateTime,
            anyChangedForDate,
            isBusySlot: true,
            UpdateFlags,
            officeDetails,
            officeIds,
            busySlotEmployeeView,
            isAllDayBusy,
            repeatedType,
            repeatedEndDate,
            originalRequestedDate,
            eventItem,
          });
          setEditModalConfirmation(true);
          return;
        }

        // Perform the update
        await performBusySlotUpdate(
          busySlotData,
          newDateTime,
          editTypesVariables.allEvent,
          officeDetails,
          officeIds,
          busySlotEmployeeView,
          isAllDayBusy,
          repeatedType,
          repeatedEndDate,
          originalRequestedDate,
          UpdateFlags,
        );
      } catch (error) {
        toast.error(error.message || t("scheduler.updateFailed"));
        throw error;
      }
    },[t, queryClient, getTimeCheck, performBusySlotUpdate, draggedEvent],
  );

  // Handle drag start
  const handleDragStart = useCallback(
    (e, eventItem, fullEvent, originalDateKey = null) => {
      if (!canDragEvent(eventItem)) {
        e.preventDefault();
        return;
      }
      const rect = e.currentTarget.getBoundingClientRect();
      const offsetX = e.clientX - rect.left;
      const offsetY = e.clientY - rect.top;

      // Store original date for all-day events to prevent same-date moves
      let originalDate = null;
      if (originalDateKey) {
        // Get the date from the dateKey (format: "MMM DD, ddd")
        const dateObj = filteredAgendaFilter?.find(
          (d) =>
            moment(d.requestedDate).format("MMM DD, ddd") === originalDateKey,
        );
        if (dateObj) {
          originalDate = moment(dateObj.requestedDate).startOf("day");
        } else {
          // Fallback: try to parse the dateKey directly
          // dateKey format is "MMM DD, ddd" (e.g., "Nov 17, Mon")
          const parsedDate = moment(originalDateKey, "MMM DD, ddd");
          if (parsedDate.isValid()) {
            // Use current year if not specified
            const currentYear = moment().year();
            originalDate = parsedDate.year(currentYear).startOf("day");
          }
        }
      } else {
        // If still no date, try to get from eventItem
        if (eventItem.date) {
          originalDate = moment(eventItem.date).startOf("day");
        } else if (eventItem.startTime) {
          originalDate = moment(eventItem.startTime).startOf("day");
        }
      }
      draggedEventDateRef.current = moment(originalDate).startOf("day");
      setDraggedEvent({
        eventItem,
        fullEvent,
        originalDate: originalDate ? originalDate.format("YYYY-MM-DD") : null,
        requestedDate: moment(originalDate).startOf("day"),
      });
      setIsDragging(true);
      setOpenTooltipId(null); // Close any open tooltips

      // Create drag preview
      const dragImage = e.currentTarget.cloneNode(true);
      dragImage.style.opacity = "0";
      dragImage.style.position = "absolute";
      dragImage.style.top = "-1000px";
      document.body.appendChild(dragImage);
      e.dataTransfer.setDragImage(dragImage, offsetX, offsetY);
      setTimeout(() => document.body.removeChild(dragImage), 0);
    },[canDragEvent, filteredAgendaFilter],
  );

  const isAllDayEvent = useCallback((eventItem) => {
    return (
      eventItem.isAllDayEvent ||
      eventItem.isAllDayBusy ||
      !eventItem.startTime ||
      !eventItem.endTime
    );
  },[]);

  // Handle drag over - validate drop zone and show preview
  const handleDragOver = useCallback(
    (e, dayIndex, hourIndex, isAllDayRow = false) => {
      if (!draggedEvent) {
        e.preventDefault();
        return;
      }

      const { eventItem } = draggedEvent;
      const isDraggedAllDay = isAllDayEvent(eventItem);

      // Prevent cross-section drops:
      // - All-day events can only drop in all-day row
      // - Time-based events can only drop in time-based rows
      if (isDraggedAllDay && !isAllDayRow) {
        e.preventDefault();
        e.dataTransfer.dropEffect = "none";
        setDragPreviewPosition(null);
        return;
      }
      if (!isDraggedAllDay && isAllDayRow) {
        e.preventDefault();
        e.dataTransfer.dropEffect = "none";
        setDragPreviewPosition(null);
        return;
      }

      e.preventDefault();
      e.dataTransfer.dropEffect = "move";

      // Calculate preview position for time-based events
      if (!isAllDayRow && !isDraggedAllDay && hourIndex !== undefined) {
        const cellElement = e.currentTarget;
        const cellRect = cellElement.getBoundingClientRect();
        const relativeY = e.clientY - cellRect.top;
        const cellHeight = cellRect.height; // Height of hour cell (60px)
        const minuteHeight = cellHeight / 60; // Each minute takes this much height
        const minutesFromHourStart = relativeY / minuteHeight;

        // Snap to 15-minute intervals
        const snappedMinutes = Math.round(minutesFromHourStart / 15) * 15;
        const clampedMinute = Math.max(0, Math.min(45, snappedMinutes));

        // Calculate duration from original event
        const originalStart = moment(eventItem.startTime);
        const originalEnd = moment(eventItem.endTime);
        const durationMinutes = originalEnd.diff(originalStart, "minutes");

        const topPercent = (clampedMinute / 60) * 100;
        const heightPercent = (durationMinutes / 60) * 100;

        setDragPreviewPosition({
          dayIndex,
          hourIndex,
          topPercent,
          heightPercent,
          clampedMinute,
        });
      } else if (isAllDayRow && isDraggedAllDay) {
        // For all-day events, just show which day
        setDragPreviewPosition({
          dayIndex,
          isAllDay: true,
        });
      }
    },[draggedEvent, isAllDayEvent],
  );

  // Calculate new date for all-day events
  const calculateNewDateForAllDay = useCallback(
    (eventItem, dayIndex, originalDateString = null) => {
      if (dayIndex < 0 || dayIndex >= weekData.length) {
        return null;
      }

      const targetDate = weekData[dayIndex];
      if (!targetDate) return null;

      const newDate = moment(targetDate.date).startOf("day");

      // Get original date - prefer stored originalDate, then try eventItem fields
      let originalDate = null;
      if (originalDateString) {
        originalDate = moment(originalDateString).startOf("day");
      } else if (eventItem.date) {
        originalDate = moment(eventItem.date).startOf("day");
      } else if (eventItem.startTime) {
        originalDate = moment(eventItem.startTime).startOf("day");
      }

      // For all-day events, check if moving to same date
      if (originalDate && newDate.isSame(originalDate, "day")) {
        return null; // Cannot move all-day event to same date
      }

      return {
        newDate: newDate.toDate(),
        newStartTime: newDate.startOf("day").toDate(),
        newEndTime: newDate.endOf("day").toDate(),
        newStartTimeString: newDate.startOf("day").format("YYYY-MM-DDTHH:mm"),
        newEndTimeString: newDate.endOf("day").format("YYYY-MM-DDTHH:mm"),
      };
    },[weekData],
  );

  const isSameDateAndTime = useCallback(
    (newDate, originalStartTimeMoment, originalDateMoment) => {
      const newDateMoment = moment(newDate.newDate).startOf("day");
      const newStartTimeMoment = moment(newDate.newStartTime);

      // Check if date hasn't changed
      const isDateSame = newDateMoment.isSame(originalDateMoment, "day");

      // Check if startTime hasn't changed (compare hours and minutes)
      const isStartTimeSame =
        newStartTimeMoment.hour() === originalStartTimeMoment.hour() &&
        newStartTimeMoment.minute() === originalStartTimeMoment.minute();

      // If date is not changed AND startTime is not changed, stop before update functions
      if (isDateSame && isStartTimeSame) {
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return true;
      }
      return false;
    },[],
  );
  // Handle drop for time-based events
  const handleDrop = useCallback(
    async (e, dayIndex, hourIndex, isAllDayRow = false) => {
      e.preventDefault();
      if (!draggedEvent || !draggedEvent.eventItem) {
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      const { eventItem } = draggedEvent;
      if (!eventItem) {
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      const isDraggedAllDay = isAllDayEvent(eventItem);

      // Validate drop zone
      if (isDraggedAllDay && !isAllDayRow) {
        toast.error(t("scheduler.cannotMoveAllDayToTimeBased"));
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }
      if (!isDraggedAllDay && isAllDayRow) {
        toast.error(t("scheduler.cannotMoveTimeBasedToAllDay"));
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      // Handle all-day event drop
      // Get original date
      const originalDateMoment = draggedEvent.originalDate
        ? moment(draggedEvent.originalDate)
        : eventItem.date
          ? moment(eventItem.date)
          : eventItem.startTime
            ? moment(eventItem.startTime)
            : null;

      const originalStartTimeMoment = eventItem.startTime
        ? moment(eventItem.startTime)
        : null;
      if (isAllDayRow && isDraggedAllDay) {
        if (!eventItem || !eventItem.id) {
          toast.error(t("scheduler.invalidEventData"));
          setIsDragging(false);
          setDraggedEvent(null);
          setDragPreviewPosition(null);
          return;
        }

        const newDate = calculateNewDateForAllDay(
          eventItem,
          dayIndex,
          draggedEvent.originalDate,
        );
        if (!newDate) {
          setIsDragging(false);
          setDraggedEvent(null);
          return;
        }

        // Check if date and startTime haven't changed - stop before update functions
        if (
          originalDateMoment &&
          originalStartTimeMoment &&
          newDate &&
          newDate.newDate &&
          newDate.newStartTime &&
          isSameDateAndTime(
            newDate,
            originalStartTimeMoment,
            originalDateMoment,
          )
        ) {
          return;
        }

        setIsDragDropLoading(true);
        try {
          if (
            eventItem.agendaType === constants.agendaType.BUSY_SLOT ||
            eventItem.agendaType === constants.agendaType.BLOCKED
          ) {
            await updateBusySlotAfterDrag(eventItem, newDate);
          } else {
            await updateEventAfterDrag(eventItem, newDate);
          }
        } catch (error) {
          // Error already shown in update functions
        } finally {
          setIsDragDropLoading(false);
          setIsDragging(false);
          setDraggedEvent(null);
          setDragPreviewPosition(null);
        }
        return;
      }

      // Handle time-based event drop
      if (!eventItem || !eventItem.id) {
        toast.error("Invalid event data");
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      const cellElement = e.currentTarget;
      const newDateTime = calculateNewDateTime(
        eventItem,
        e.clientX,
        e.clientY,
        cellElement,
        dayIndex,
        hourIndex,
      );

      // Check for time range exceeded error
      if (newDateTime && newDateTime.error === "timeRangeExceeded") {
        toast.error("You can't move the event outside the time range");
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      if (!newDateTime) {
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        return;
      }

      // Check if date and startTime haven't changed - stop before update functions
      if (
        originalDateMoment &&
        originalStartTimeMoment &&
        newDateTime &&
        newDateTime.newDate &&
        newDateTime.newStartTime &&
        isSameDateAndTime(
          newDateTime,
          originalStartTimeMoment,
          originalDateMoment,
        )
      ) {
        return;
      }

      setIsDragDropLoading(true);
      try {
        // Update based on event type
        if (
          eventItem.agendaType === constants.agendaType.BUSY_SLOT ||
          eventItem.agendaType === constants.agendaType.BLOCKED
        ) {
          await updateBusySlotAfterDrag(eventItem, newDateTime);
        } else {
          await updateEventAfterDrag(eventItem, newDateTime);
        }
      } catch (error) {
        // Error already shown in update functions
      } finally {
        setIsDragDropLoading(false);
        setIsDragging(false);
        setDraggedEvent(null);
        setDragPreviewPosition(null);
        setOpenTooltipId(null);
      }
    },[
      draggedEvent,
      isAllDayEvent,
      calculateNewDateTime,
      calculateNewDateForAllDay,
      updateEventAfterDrag,
      updateBusySlotAfterDrag,
      currentDate,
      onDateChange,
      t,
      weekData,
    ],
  );

  // Handle drag end
  const handleDragEnd = useCallback(() => {
    // Only reset loading if not currently processing a drop
    if (!isDragDropLoading) {
      setIsDragging(false);
      setDraggedEvent(null);
      setDragPreviewPosition(null);
    }
  },[isDragDropLoading]);

  const renderEventContent = (event, dotColor) => {
    if (!event) return null;
    const eventItem = event.item || event;
    if (!eventItem) return null;
    const user = event.user || null;
    return (
      <span className={styles.eventTextWrapper}>
        <span
          className={styles.eventDot}
          style={{ backgroundColor: dotColor || "#005f99" }}
        ></span>
        <span className={styles.eventTextContent}>
          {getEventDisplayText(eventItem, user)}
        </span>
      </span>
    );
  };

  const handleTogglePopup = () => {
    setShowPopup((prev) => !prev);
  };

  useEffect(() => {
    const updatePosition = () => {
      if (showPopup && containerRef.current && popupRef.current) {
        const containerRect = containerRef.current.getBoundingClientRect();
        const popupRect = popupRef.current.getBoundingClientRect();
        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;
        const margin = 8;

        let left = containerRect.left;
        let top = containerRect.bottom + 8;

        if (left + popupRect.width + margin > screenWidth) {
          left = screenWidth - popupRect.width - margin;
        }

        if (left < margin) {
          left = margin;
        }

        if (top + popupRect.height + margin > screenHeight) {
          top = containerRect.top - popupRect.height - margin;
        }

        setPosition({ left, top });
      }
    };

    if (showPopup) {
      updatePosition();

      window.addEventListener("scroll", updatePosition);
      window.addEventListener("resize", updatePosition);
    }

    return () => {
      window.removeEventListener("scroll", updatePosition);
      window.removeEventListener("resize", updatePosition);
    };
  }, [showPopup]);

  // Scroll to highlighted date and cleanup query param (matching AgendaWeeklyView)
  useEffect(() => {
    if (!search || !filteredAgendaFilter?.length || !weeklyData?.data?.length)
      return;
    if (highlightRef.current) {
      setTimeout(() => {
        highlightRef.current.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "center",
        });
      }, 500);
    }
    const timeOut = setTimeout(() => {
      const queryParams = new URLSearchParams(search);
      if (queryParams.has(showTime)) {
        queryParams.delete(showTime);
        history.replace({
          search: queryParams.toString(),
        });
      }
    }, 3000);
    return () => {
      clearTimeout(timeOut);
    };
  },[search, filteredAgendaFilter, weeklyData, history]);
  // Scroll to scroll hour
  useEffect(() => {
    if (!startTime) return;
    if (currentHourRowRef.current && !focusOnFirstAvailableSlot?.current) {
      const timeOut = setTimeout(() => {
        currentHourRowRef.current.scrollIntoView({
          behavior: "smooth",
          inline: "center",
          block: "center",
        });
      }, 500);
      return () => {
        clearTimeout(timeOut);
      };
    }
  }, [startTime]);

  useEffect(() => {
    if (popUpRef.current && hoverKey) {
      const parentTr =
        popUpRef.current.parentElement.parentElement.parentElement.getBoundingClientRect();
      const td =
        popUpRef.current.parentElement.parentElement.getBoundingClientRect();
      if (parentTr.right - td.right <= 430) {
        popUpRef.current.style.left = "-420px";
      }
    }
  }, [hoverKey]);
  // Update findCommonAvailabilitySlots to use 1-minute increments
  const findCommonAvailabilitySlots = useCallback(
    (staffList, officeStart, officeEnd) => {
      // Convert each staff's schedule into busy time slots
      const busySlots = staffList.map((staff) => {
        const allEvents = getAllStaffEvents(staff);
        return allEvents.map((event) => ({
          start: getTimeInMinutes(event.startTime),
          end: getTimeInMinutes(event.endTime),
        }));
      });

      // Calculate office hours range in minutes
      const officeStartMinutes = officeStart
        ? getTimeInMinutes(officeStart)
        : 0;
      const officeEndMinutes = officeEnd
        ? getTimeInMinutes(officeEnd)
        : 24 * 60;

      // Find all possible time slots (in 1-minute increments) between officeStart and officeEnd
      const timeSlots =[];
      for (
        let minute = officeStartMinutes;
        minute < officeEndMinutes;
        minute += 1
      ) {
        const startTime = minute;
        const endTime = startTime + 1;
        timeSlots.push({ start: startTime, end: endTime });
      }

      // Find slots where all staff are free
      const commonAvailability = timeSlots.filter((slot) => {
        return !busySlots.some((staffBusySlots) =>
          staffBusySlots.some(
            (busySlot) =>
              // Fixed boundary condition: slot overlaps if it touches or crosses event boundaries
              slot.start < busySlot.end && slot.end > busySlot.start,
          ),
        );
      });

      // Merge consecutive slots
      const mergedSlots =[];
      let currentSlot = null;

      commonAvailability.forEach((slot) => {
        if (!currentSlot) {
          currentSlot = { ...slot };
        } else if (slot.start === currentSlot.end) {
          currentSlot.end = slot.end;
        } else {
          mergedSlots.push(currentSlot);
          currentSlot = { ...slot };
        }
      });

      if (currentSlot) {
        mergedSlots.push(currentSlot);
      }
      // Filter slots that are at least 1 minute long
      return mergedSlots.filter((slot) => slot.end - slot.start >= 1);
    },
    [getAllStaffEvents, getTimeInMinutes],
  );
  const commonAvailabilitySlots = useMemo(() => {
    if (showFreeSlots && filteredAgendaFilter.length) {
      const dateObj = filteredAgendaFilter?.find((d) =>
        moment(d.requestedDate)
          .startOf("day")
          .isSame(moment(currentDate).startOf("day")),
      );

      if (dateObj?.officeSchedulerList) {
        return findCommonAvailabilitySlots(
          dateObj.officeSchedulerList,
          findAvailabilityData.officeStart,
          findAvailabilityData.officeEnd,
        );
      }
    }

    return [];
  },[
    showFreeSlots,
    currentDate,
    filteredAgendaFilter,
    findCommonAvailabilitySlots,
    findAvailabilityData,
  ]);
  const scrollReferenceForFirst = useRef(null);
  // Scroll to first availability slot when slots are available
  useEffect(() => {
    if (
      commonAvailabilitySlots.length > 0 &&
      firstAvailabilitySlotRef.current &&
      focusOnFirstAvailableSlot?.current
    ) {
      // Use setTimeout to ensure the element is rendered before scrolling
      scrollReferenceForFirst.current = null;
      setTimeout(() => {
        firstAvailabilitySlotRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
        if (resetFocusRef) {
          resetFocusRef();
        }
      }, 1000);
    }
  }, [commonAvailabilitySlots]);

  if (isLoading || isFreeStotLoading) {
    return <Loader />;
  }

  if (!weeklyData?.data?.length && !isLoading) {
    return <Empty Message={t("scheduler.noEventsFound")} />;
  }

  const hasAnyHoliday = days.some((day) => {
    const dateObj = filteredAgendaFilter?.find(
      (d) => moment(d.requestedDate).format("MMM DD, ddd") === day.date,
    );
    return (dateObj?.holidayList ||[]).length > 0;
  });

  return (
    <>
      {isDragDropLoading && <Loader />}

      {/* Hidden container for accurate width measurement */}
      <div
        ref={measurementContainerRef}
        className={styles.office_list_main_container}
        style={{
          position: "absolute",
          visibility: "hidden",
          top: -9999,
          left: 0,
          width: "max-content", // Important: force single line layout
          height: 0,
          overflow: "hidden",
          pointerEvents: "none",
          // Reset padding/gap if needed to measure pure content,
          // but better to let it inherit class styles to match font/spacing.
        }}
        aria-hidden="true"
      >
        {officeList.map((item) => (
          <div
            key={item.id}
            className={styles.office_list_container}
            style={{ backgroundColor: item.color }}
          >
            <img
              src={item.profilePic || defautUserImage}
              alt={item.name}
              className={styles.office_list_image}
              onError={(e) => {
                e.currentTarget.src = defautUserImage;
              }}
            />
            <div className={styles.office_name_container}>
              <p className={styles.office_staff_name}>{item.name}</p>
            </div>
          </div>
        ))}
        {/* Dummy button rendered exactly as real one */}
        <div ref={dummyMoreBtnRef} className={styles.more_btn_wrapper}>
          <button className={styles.more_btn}></button>
        </div>
      </div>

      <div
        className={styles.office_list_main_container}
        ref={tableContainerRef}
      >
        {visibleOffices.map((item) => (
          <div
            key={item.id}
            className={styles.office_list_container}
            style={{ backgroundColor: item.color }}
          >
            <img
              src={item.profilePic || defautUserImage}
              alt={item.name}
              className={styles.office_list_image}
              onError={(e) => {
                e.currentTarget.src = defautUserImage;
              }}
            />
            <div className={styles.office_name_container}>
              <p className={styles.office_staff_name}>{item.name}</p>
            </div>
          </div>
        ))}

        {hiddenOffices.length > 0 && (
          <div className={styles.more_btn_wrapper}>
            <button
              className={styles.more_btn}
              onClick={handleTogglePopup}
              ref={containerRef}
            >
              + {hiddenOffices.length} more
            </button>

            {showPopup && (
              <div
                className={styles.popupOverlay}
                ref={popupRef}
                style={{
                  left: position.left,
                  top: position.top,
                }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className={styles.popupContainer}>
                  <div className={styles.popupHeader}>
                    <button
                      className={styles.closeBtn}
                      onClick={() => setShowPopup(false)}
                    >
                      <img
                        src={CloseIcon}
                        alt="close"
                        className={styles.closeIcon}
                      />
                    </button>
                  </div>

                  <div className={styles.popupContent}>
                    {hiddenOffices.map((item) => (
                      <div key={item.id} className={styles.popupStaffCard}>
                        <span
                          className={styles.eventDot}
                          style={{ backgroundColor: item.dotColor }}
                        ></span>
                        <img
                          src={item.profilePic || defautUserImage}
                          alt={item.name}
                          className={styles.office_list_image_modal}
                          onError={(e) => {
                            e.currentTarget.src = defautUserImage;
                          }}
                        />
                        <div>
                          <p className={styles.office_staff_name_modal}>
                            {item.name}
                          </p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      <div
        className={styles.calendarWrapper}
        ref={calendarWrapperRef}
        style={{
          maxHeight: tableHeight,
          overflow: "auto",
        }}
        onScroll={() => {
          if (openTooltipId) {
            setOpenTooltipId(null);
          }
        }}
      >
        <table className={styles.calendarTable}>
          <thead>
            {/* Row 1: Date headers */}
            <tr>
              <th className={styles.timeHeader}>
                <div className={styles.empty}></div>
              </th>
              {days.map((day, i) => {
                const dayMoment =
                  day.momentDate || moment(day.date, "MMM DD, ddd");
                const highlightCheck =
                  dateMatchForHighlight &&
                  dayMoment &&
                  moment(dateMatchForHighlight)
                    .startOf("day")
                    .isSame(dayMoment.startOf("day"));
                const selectedDateSameColumn = moment(currentDate)
                  .startOf("day")
                  .isSame(dayMoment);

                const cellStyle = {};
                if (isSchedulingAssistant && selectedDateSameColumn) {
                  cellStyle.borderRight = "2px solid #a9cf3d";
                  cellStyle.borderLeft = "2px solid #a9cf3d";
                  cellStyle.borderTop = "2px solid #a9cf3d";
                }
                return (
                  <th
                    key={i}
                    ref={highlightCheck ? highlightRef : undefined}
                    className={`${styles.dayHeader} ${
                      highlightCheck ? "blinking-background" : ""
                    }`}
                    style={cellStyle}
                  >
                    <div>{day.date}</div>
                  </th>
                );
              })}
            </tr>

            {/* Row 2: Holiday indicators */}
            {hasAnyHoliday && (
              <tr>
                <th className={styles.timeHeader}>
                  <div className={styles.empty_holi}></div>
                </th>
                {days.map((day, i) => {
                  const dateKey = day.date;
                  const dateObj = filteredAgendaFilter?.find(
                    (d) =>
                      moment(d.requestedDate).format("MMM DD, ddd") === dateKey,
                  );
                  const holidayList = dateObj?.holidayList ||[];

                  return (
                    <th key={`holiday-${i}`} className={styles.holiday_header}>
                      {holidayList.length > 0 ? (
                        <div className={styles.holiday_container}>
                          <img src={HolidayImage} alt="holiday" />
                          <p className={styles.holiday_text}>
                            {holidayList[0]?.title || "HOLIDAY"}
                          </p>
                        </div>
                      ) : (
                        <div style={{ height: "32px" }}></div>
                      )}
                    </th>
                  );
                })}
              </tr>
            )}

            {/* All-day events row */}
            <tr>
              <th
                className={`${styles.timeHeader} ${styles.all_day_event_header}`}
              >
                <div className={styles.all_day_text}>
                  <p>all-day</p>
                </div>
              </th>
              {days.map((day, dIndex) => {
                const dateKey = day.date;
                const dayMoment =
                  day.momentDate || moment(day.date, "MMM DD, ddd");
                const allDayEventsForDate = allDayEventsMap[dateKey] || {};
                const selectedDateSameColumn =
                  moment(currentDate).format("MMM DD, ddd") === dateKey;
                // Get all events for all users for this date
                const dateObj = filteredAgendaFilter?.find(
                  (d) =>
                    moment(d.requestedDate).format("MMM DD, ddd") === dateKey,
                );
                const holidayList = dateObj?.holidayList ||[];
                const allEventsForDate =
                  Object.values(allDayEventsForDate).flat();
                const highlightCheck =
                  dateMatchForHighlight &&
                  dayMoment &&
                  moment(dateMatchForHighlight)
                    .startOf("day")
                    .isSame(dayMoment.startOf("day"));
                const cellStyle = {};
                if (isSchedulingAssistant && selectedDateSameColumn) {
                  cellStyle.borderRight = "2px solid #a9cf3d";
                  cellStyle.borderLeft = "2px solid #a9cf3d";
                }
                return (
                  <td
                    key={dIndex}
                    className={`${styles.eventCell} ${
                      holidayList.length > 0 ? styles.light_red_bg : ""
                    } ${highlightCheck ? "blinking-background" : ""}`}
                    onDragOver={(e) => handleDragOver(e, dIndex, 0, true)}
                    onDrop={(e) => handleDrop(e, dIndex, 0, true)}
                    style={cellStyle}
                  >
                    {allEventsForDate.map((event, eIndex) => {
                      if (!event || !event.user || !event.item) return null;
                      const thisHoverKey = `allday-${dIndex}-${eIndex}`;
                      const eventItem = event.item;
                      const createdByMe =
                        eventItem.createdById === currentUserId;
                      const createdByOthers =
                        eventItem?.isShift &&
                        profile?.id !== eventItem?.createdById;
                      const canDrag = canDragEvent(eventItem);
                      const isDragged =
                        isDragging &&
                        draggedEvent?.eventItem?.id === eventItem.id;

                      // Determine click behavior based on event type (same as StaffAvailabilityWeeklyView)
                      let shouldNavigate = false;
                      let shouldShowPopup = false;

                      if (eventItem.agendaType === constants.agendaType.EVENT) {
                        // Events/Shifts: Navigate if can edit, else show popup
                        shouldNavigate =
                          createdByMe ||
                          (createdByOthers &&
                            canEditAndViewOthersData(eventItem?.officeId));
                        shouldShowPopup = !shouldNavigate;
                      } else if (
                        eventItem.agendaType ===
                          constants.agendaType.BUSY_SLOT ||
                        eventItem.agendaType === constants.agendaType.BLOCKED
                      ) {
                        // Busy Slots: Navigate if created by user, else show popup
                        shouldNavigate = createdByMe;
                        shouldShowPopup = !shouldNavigate;
                      } else if (
                        eventItem.agendaType ===
                        constants.agendaType.APPOINTMENT
                      ) {
                        // Appointments: Always show popup
                        shouldShowPopup = true;
                      } else if (
                        eventItem.agendaType === constants.agendaType.LEAVE
                      ) {
                        // Leaves: Always show popup
                        shouldShowPopup = true;
                      }

                      const tooltipId = `tooltip-allday-${dIndex}-${eIndex}-${
                        eventItem?.id || eIndex
                      }`;
                      return (
                        <React.Fragment key={eIndex}>
                          <div
                            id={tooltipId}
                            className={styles.eventBox}
                            draggable={canDrag}
                            onDragStart={(e) =>
                              handleDragStart(e, eventItem, event, dateKey)
                            }
                            onDragEnd={handleDragEnd}
                            onMouseEnter={() => {
                              if (!isDragging) {
                                toggleTooltip(tooltipId);
                              }
                            }}
                            onMouseLeave={() => {
                              toggleTooltip(tooltipId);
                            }}
                            style={{
                              backgroundColor: event.bgColor,
                              cursor: canDrag
                                ? "grab"
                                : shouldNavigate || shouldShowPopup
                                  ? "pointer"
                                  : "default",
                              opacity: isDragged ? 0 : 1,
                              border: "1px solid rgba(0, 0, 0, 0.2)", // Added white border for all-day events
                            }}
                            onClick={(e) => {
                              if (isDragging) {
                                e.stopPropagation();
                                return;
                              }
                              if (shouldNavigate) {
                                const requestedDate = dateObj?.requestedDate;
                                const canEdit =
                                  createdByMe ||
                                  (createdByOthers &&
                                    canEditAndViewOthersData(
                                      eventItem?.officeId,
                                    ));
                                goToDetails(
                                  eventItem.id,
                                  eventItem.agendaType,
                                  canEdit,
                                  requestedDate,
                                );
                              } else if (shouldShowPopup) {
                                setHoverKey(thisHoverKey);
                              } else {
                                toggleTooltip(tooltipId);
                              }
                            }}
                          >
                            {renderEventContent(event, event.dotColor)}
                          </div>
                          <Tooltip
                            placement="top"
                            isOpen={openTooltipId === tooltipId && !isDragged}
                            target={tooltipId}
                            autohide={false}
                            toggle={() => toggleTooltip(tooltipId)}
                            className="weekly_list_tooltip_style"
                          >
                            <div className={styles.tooltip_content}>
                              <div
                                className={styles.image_border}
                                style={{
                                  border: `2px solid ${getOfficeColor(
                                    event.user,
                                    selectedOwnerId,
                                  )}`,
                                }}
                              >
                                <img
                                  src={event.user.profilePic || defautUserImage}
                                  alt={eventItem?.title || ""}
                                  onError={(e) => {
                                    e.currentTarget.src = defautUserImage;
                                  }}
                                  className={styles.tooltip_image}
                                />
                              </div>
                              <div>
                                <p className={styles.staff_name}>
                                  {event.user.fullName}
                                </p>
                                {renderOfficeNameOrEnterprise(eventItem, t) && (
                                  <div
                                    className={styles.chip}
                                    style={{
                                      backgroundColor: getOfficeColor(
                                        event.user,
                                        eventItem?.officeId,
                                        selectedOwnerId,
                                      ),
                                      color: "#FFFFFF",
                                    }}
                                  >
                                    {renderOfficeNameOrEnterprise(eventItem, t)}
                                  </div>
                                )}
                              </div>
                            </div>
                          </Tooltip>
                          {thisHoverKey === hoverKey &&
                            shouldShowPopup &&
                            getPopupView(
                              eventItem,
                              getBackgroundColorClass(eventItem),
                              getTagColorClass(eventItem),
                              dateObj?.requestedDate,
                              event.user.fullName,
                            )}
                        </React.Fragment>
                      );
                    })}
                    {/* Drag preview for all-day events */}
                    {isDragging &&
                      dragPreviewPosition &&
                      dragPreviewPosition.isAllDay &&
                      dragPreviewPosition.dayIndex === dIndex &&
                      draggedEvent &&
                      draggedEvent.eventItem && (
                        <div
                          style={{
                            backgroundColor: getEventColor(
                              draggedEvent.eventItem,
                            ),
                            border: `2px dashed ${getEventBorderColor(
                              draggedEvent.eventItem,
                            )}`,
                            borderRadius: 4,
                            opacity: 0.6,
                            padding: "4px 8px",
                            marginTop: "4px",
                            pointerEvents: "none",
                            fontSize: "12px",
                          }}
                        >
                          {draggedEvent.fullEvent
                            ? renderEventContent(
                                draggedEvent.fullEvent,
                                draggedEvent.fullEvent?.dotColor || "#005f99",
                              )
                            : renderEventContent(
                                { item: draggedEvent.eventItem },
                                "#005f99",
                              )}
                        </div>
                      )}
                  </td>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {/* Time-based events rows */}
            {hours.map((hour, hIndex) => {
              const isLastHourTab = hIndex === hours.length - 1;
              return (
                <tr
                  key={hIndex}
                  ref={hIndex === scrollHour ? currentHourRowRef : null}
                >
                  <td
                    className={styles.timeColumn}
                    onClick={() => {
                      if (typeof onTimeLabelClick === "function")
                        onTimeLabelClick(hIndex);
                    }}
                    style={{
                      borderLeft: "1px solid #ddd",
                      borderRight: "1px solid #ddd",
                      ...(selectedHourIdx === hIndex && startTime
                        ? {
                            borderTop: "2px solid #a9cf3d",
                            borderBottom: "2px solid #a9cf3d",
                            borderLeft: "2px solid #a9cf3d",
                          }
                        : {}),
                      cursor: "pointer",
                      position: "sticky",
                      top:0
                    }}
                  >
                    <div className={styles.date_container}>{hour.label}</div>
                    {startTime &&
                      (() => {
                        const startHour = moment.isMoment(startTime)
                          ? startTime.hour()
                          : moment(startTime,["h:mm A", "HH:mm"]).hour();
                        const startMinute = moment.isMoment(startTime)
                          ? startTime.minute()
                          : moment(startTime, ["h:mm A", "HH:mm"]).minute();

                        if (hIndex === startHour) {
                          const topPosition = (startMinute / 60) * 100;
                          return (
                            <div
                              className={styles.time_indicator_container}
                              style={{
                                top: `${topPosition}%`,
                              }}
                            >
                              <div className={styles.time_indicator_circle} />
                              <div className={styles.time_indicator_line} />
                            </div>
                          );
                        }
                      })()}
                  </td>
                  {days.map((day, dIndex) => {
                    const dateKey = day.date;
                    const dayMoment =
                      day.momentDate || moment(day.date, "MMM DD, ddd");
                    const dateObj = filteredAgendaFilter?.find(
                      (d) =>
                        moment(d.requestedDate).format("MMM DD, ddd") ===
                        dateKey,
                    );

                    const selectedDateSameColumn =
                      moment(currentDate).format("MMM DD, ddd") === dateKey;

                    const holidayList = dateObj?.holidayList || [];
                    const allTimeEvents = timeEventsByDate[dateKey] ||[];
                    const highlightCheck =
                      dateMatchForHighlight &&
                      dayMoment &&
                      moment(dateMatchForHighlight)
                        .startOf("day")
                        .isSame(dayMoment.startOf("day"));

                    // Calculate hour boundaries in minutes
                    const hourStartMinutes = hIndex * 60;
                    const hourEndMinutes = (hIndex + 1) * 60;

                    // Filter events that overlap with this hour
                    const overlappingEvents = allTimeEvents.filter((event) => {
                      if (
                        !event ||
                        !event.item ||
                        !event.item.startTime ||
                        !event.item.endTime
                      ) {
                        return false;
                      }
                      const startMinutes = getTimeInMinutes(
                        event.item.startTime,
                      );
                      const endMinutes = getTimeInMinutes(event.item.endTime);
                      return (
                        startMinutes < hourEndMinutes &&
                        endMinutes > hourStartMinutes
                      );
                    });

                    // Create a Map to preserve full event data with a unique key
                    // Use item reference + user ID to ensure uniqueness even if events have same ID/time
                    const eventMap = new Map();
                    overlappingEvents.forEach((fullEvent, idx) => {
                      if (!fullEvent || !fullEvent.item) return;
                      const item = fullEvent.item;
                      // Create unique key: id + startTime + endTime + user.id to handle same events for different users
                      const uniqueKey = `${item.id || idx}-${
                        item.startTime || ""
                      }-${item.endTime || ""}-${fullEvent.user?.id || idx}`;
                      eventMap.set(uniqueKey, fullEvent);
                      // Also set a simpler key for fallback
                      const simpleKey = `${item.id || idx}-${
                        item.startTime || ""
                      }-${item.endTime || ""}`;
                      if (!eventMap.has(simpleKey)) {
                        eventMap.set(simpleKey, fullEvent);
                      }
                    });

                    // Group events by start time for overlap calculation
                    const groupedEvents = groupEventsByStartTime(
                      overlappingEvents.map((e) => e.item).filter(Boolean),
                    );

                    let cellStyle = {
                      position: "relative",
                      height: "60px",
                    };
                    if (
                      startTime &&
                      selectedHourIdx === hIndex &&
                      selectedDateSameColumn
                    ) {
                      cellStyle.borderTop = "2px solid #a9cf3d";
                      cellStyle.borderBottom = "2px solid #a9cf3d";
                      cellStyle.borderRight = "2px solid #a9cf3d";
                      cellStyle.borderLeft = "2px solid #a9cf3d";
                    }
                    if (isSchedulingAssistant) {
                      if (selectedDateSameColumn) {
                        cellStyle.borderRight = "2px solid #a9cf3d";
                        cellStyle.borderLeft = "2px solid #a9cf3d";
                      }
                      if (selectedDateSameColumn && isLastHourTab) {
                        cellStyle.borderBottom = "2px solid #a9cf3d";
                      }
                      if (
                        startTime &&
                        !selectedDateSameColumn &&
                        selectedHourIdx === hIndex
                      ) {
                        cellStyle.borderTop = "2px solid #a9cf3d";
                        cellStyle.borderBottom = "2px solid #a9cf3d";
                      }
                    }
                    return (
                      <td
                        key={dIndex}
                        className={`${styles.eventCell} ${
                          holidayList.length > 0 ? styles.light_red_bg : ""
                        } ${highlightCheck ? "blinking-background" : ""}`}
                        style={cellStyle}
                        onDragOver={(e) =>
                          handleDragOver(e, dIndex, hIndex, false)
                        }
                        onDrop={(e) => handleDrop(e, dIndex, hIndex, false)}
                      >
                        {/* Common availability slots - only show when showFreeSlots is true */}
                        {showFreeSlots &&
                          selectedDateSameColumn &&
                          commonAvailabilitySlots.map((slot, index) => {
                            // Calculate the start and end of the current hour in minutes
                            const hourStart = hIndex * 60;
                            const hourEnd = (hIndex + 1) * 60;
                            // Check if the slot overlaps with the current hour cell
                            if (slot.start < hourEnd && slot.end > hourStart) {
                              if (scrollReferenceForFirst.current === null) {
                                scrollReferenceForFirst.current = hIndex;
                              }

                              // Calculate the effective start and end within this hour
                              const effectiveStart = Math.max(
                                slot.start,
                                hourStart,
                              );
                              const effectiveEnd = Math.min(slot.end, hourEnd);
                              const top =
                                ((effectiveStart - hourStart) / 60) * 100;
                              let height =
                                ((effectiveEnd - effectiveStart) / 60) * 100;

                              // Minimum height logic for available slot
                              let slotHeightPx =
                                (height / 100) * HOUR_CELL_HEIGHT_PX;
                              if (slotHeightPx < MIN_EVENT_HEIGHT_PX) {
                                slotHeightPx = MIN_EVENT_HEIGHT_PX;
                              }
                              const heightPercent =
                                (slotHeightPx / HOUR_CELL_HEIGHT_PX) * 100;

                              // Calculate effective start and end dates for the slot click handler
                              const hourCellStartMoment = moment(currentDate)
                                .startOf("day")
                                .add(hIndex, "hours");
                              const slotStartMoment = moment(currentDate)
                                .startOf("day")
                                .add(slot.start, "minutes");
                              const hourCellEndMoment = moment(currentDate)
                                .startOf("day")
                                .add(hIndex + 1, "hours");
                              const slotEndMoment = moment(currentDate)
                                .startOf("day")
                                .add(slot.end, "minutes");
                              const effectiveStartDate = moment
                                .max(hourCellStartMoment, slotStartMoment)
                                .toDate();
                              const effectiveEndDate = moment
                                .min(slotEndMoment, hourCellEndMoment)
                                .toDate();

                              return (
                                <div
                                  key={`availability-${index}`}
                                  ref={
                                    scrollReferenceForFirst.current === hIndex
                                      ? firstAvailabilitySlotRef
                                      : null
                                  }
                                  style={{
                                    position: "absolute",
                                    top: `${top}%`,
                                    left: 2,
                                    right: 2,
                                    height: `${heightPercent}%`,
                                    borderRadius: 6,
                                    backgroundColor: "rgba(144, 238, 144, 0.3)",
                                    border:
                                      "1px solid rgba(144, 238, 144, 0.5)",
                                    zIndex: 1,
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "10px",
                                    fontWeight: 600,
                                    color: "#2D3245",
                                    cursor: onFreeSlotClick
                                      ? "pointer"
                                      : "default",
                                  }}
                                  onClick={() => {
                                    if (onFreeSlotClick) {
                                      onFreeSlotClick(
                                        effectiveStartDate,
                                        effectiveEndDate, // Use the actual end of the available slot
                                      );
                                    }
                                  }}
                                >
                                  {t("availableSlot")}
                                </div>
                              );
                            }
                            return null;
                          })}

                        {Object.entries(groupedEvents).map(
                          ([startMinutesStr, group]) => {
                            const overlapPositions =
                              calculateOverlapPositions(group);

                            // Track which full events we've already matched to avoid reusing them
                            const usedEvents = new Set();

                            return overlapPositions.map(
                              (
                                {
                                  event: eventItem,
                                  widthFactor,
                                  leftOffsetFactor,
                                },
                                index,
                              ) => {
                                // Find the full event by matching with all overlapping events
                                // Use a Set to track which events we've already matched to ensure one-to-one mapping
                                let finalEvent = null;

                                // Find the first matching event that hasn't been used yet
                                for (const fullEvent of overlappingEvents) {
                                  // Skip if we've already used this event or if fullEvent/item is invalid
                                  if (
                                    usedEvents.has(fullEvent) ||
                                    !fullEvent ||
                                    !fullEvent.item
                                  )
                                    continue;

                                  // Match by comparing item properties
                                  if (
                                    fullEvent.item.id === eventItem.id &&
                                    fullEvent.item.startTime ===
                                      eventItem.startTime &&
                                    fullEvent.item.endTime === eventItem.endTime
                                  ) {
                                    finalEvent = fullEvent;
                                    usedEvents.add(fullEvent); // Mark as used
                                    break;
                                  }
                                }

                                // If still not found with exact match, try without endTime
                                if (!finalEvent) {
                                  for (const fullEvent of overlappingEvents) {
                                    if (
                                      usedEvents.has(fullEvent) ||
                                      !fullEvent ||
                                      !fullEvent.item
                                    )
                                      continue;

                                    if (
                                      fullEvent.item.id === eventItem.id &&
                                      fullEvent.item.startTime ===
                                        eventItem.startTime
                                    ) {
                                      finalEvent = fullEvent;
                                      usedEvents.add(fullEvent);
                                      break;
                                    }
                                  }
                                }

                                if (!finalEvent || !finalEvent.user)
                                  return null;

                                const startMinutes = getTimeInMinutes(
                                  eventItem.startTime,
                                );
                                const endMinutes = getTimeInMinutes(
                                  eventItem.endTime,
                                );

                                // Calculate position within the hour cell
                                const eventStartInHour = Math.max(
                                  startMinutes,
                                  hourStartMinutes,
                                );
                                const eventEndInHour = Math.min(
                                  endMinutes,
                                  hourEndMinutes,
                                );

                                const top =
                                  ((eventStartInHour - hourStartMinutes) / 60) *
                                  100;
                                let height =
                                  ((eventEndInHour - eventStartInHour) / 60) *
                                  100;

                                // Minimum height for small events (similar to SchedulingTable)
                                const HOUR_CELL_HEIGHT_PX = 60;
                                const MIN_EVENT_HEIGHT_PX = 8;
                                let eventHeightPx =
                                  (height / 100) * HOUR_CELL_HEIGHT_PX;
                                let topPx = (top / 100) * HOUR_CELL_HEIGHT_PX;

                                if (eventHeightPx < MIN_EVENT_HEIGHT_PX) {
                                  eventHeightPx = MIN_EVENT_HEIGHT_PX;
                                  if (
                                    eventHeightPx + topPx >
                                    HOUR_CELL_HEIGHT_PX
                                  ) {
                                    eventHeightPx = HOUR_CELL_HEIGHT_PX - topPx;
                                  }
                                }
                                const heightPercent =
                                  (eventHeightPx / HOUR_CELL_HEIGHT_PX) * 100;
                                const topPercent =
                                  (topPx / HOUR_CELL_HEIGHT_PX) * 100;

                                // Check if this is the first hour of the event
                                const eventStartHour = Math.floor(
                                  startMinutes / 60,
                                );
                                const isFirstHourOfEvent =
                                  eventStartHour === hIndex;

                                // Check if event continues to next hour
                                const continuesNextHour =
                                  endMinutes > hourEndMinutes;
                                const continuesFromPrevHour =
                                  startMinutes < hourStartMinutes;

                                const eventColor = getEventColor(eventItem);

                                const thisHoverKey = `tooltip-${hIndex}-${dIndex}-${
                                  eventItem?.id || index
                                }-${index}`;
                                const createdByMe =
                                  eventItem.createdById === currentUserId;
                                const createdByOthers =
                                  eventItem?.isShift &&
                                  profile?.id !== eventItem?.createdById;
                                const canDrag = canDragEvent(eventItem);
                                const isDragged =
                                  isDragging &&
                                  draggedEvent?.eventItem?.id === eventItem.id;

                                // Determine click behavior based on event type (same as StaffAvailabilityWeeklyView)
                                let shouldNavigate = false;
                                let shouldShowPopup = false;

                                if (
                                  eventItem.agendaType ===
                                  constants.agendaType.EVENT
                                ) {
                                  // Events/Shifts: Navigate if can edit, else show popup
                                  shouldNavigate =
                                    createdByMe ||
                                    (createdByOthers &&
                                      canEditAndViewOthersData(
                                        eventItem?.officeId,
                                      ));
                                  shouldShowPopup = !shouldNavigate;
                                } else if (
                                  eventItem.agendaType ===
                                    constants.agendaType.BUSY_SLOT ||
                                  eventItem.agendaType ===
                                    constants.agendaType.BLOCKED
                                ) {
                                  // Busy Slots: Navigate if created by user, else show popup
                                  shouldNavigate = createdByMe;
                                  shouldShowPopup = !shouldNavigate;
                                } else if (
                                  eventItem.agendaType ===
                                  constants.agendaType.APPOINTMENT
                                ) {
                                  // Appointments: Always show popup
                                  shouldShowPopup = true;
                                } else if (
                                  eventItem.agendaType ===
                                  constants.agendaType.LEAVE
                                ) {
                                  // Leaves: Always show popup
                                  shouldShowPopup = true;
                                }

                                // Use finalEvent for drag operations too
                                const fullEventForDrag = finalEvent;
                                const tooltipId = `tooltip-${hIndex}-${dIndex}-${
                                  eventItem?.id || index
                                }-${index}`;

                                return (
                                  <React.Fragment
                                    key={`${eventItem.id}-${index}`}
                                  >
                                    <div
                                      id={tooltipId}
                                      draggable={canDrag}
                                      onDragStart={(e) =>
                                        handleDragStart(
                                          e,
                                          eventItem,
                                          fullEventForDrag,
                                          day.date,
                                        )
                                      }
                                      onDragEnd={handleDragEnd}
                                      onMouseEnter={() => {
                                        if (!isDragging) {
                                          toggleTooltip(tooltipId);
                                        }
                                      }}
                                      onMouseLeave={() => {
                                        toggleTooltip(tooltipId);
                                      }}
                                      style={{
                                        position: "absolute",
                                        top: `${topPercent}%`,
                                        left: `${leftOffsetFactor * 100}%`,
                                        width: `${widthFactor * 100 - 1}%`,
                                        height: `${heightPercent}%`,
                                        backgroundColor: eventColor,
                                        borderRadius:
                                          continuesFromPrevHour ||
                                          continuesNextHour
                                            ? 0
                                            : 6,
                                        borderTopLeftRadius:
                                          continuesFromPrevHour ? 0 : 6,
                                        borderTopRightRadius:
                                          continuesFromPrevHour ? 0 : 6,
                                        borderBottomLeftRadius:
                                          continuesNextHour ? 0 : 6,
                                        borderBottomRightRadius:
                                          continuesNextHour ? 0 : 6,
                                        zIndex: isDragged ? 1000 : 2,
                                        overflow: "hidden",
                                        cursor: canDrag
                                          ? "grab"
                                          : shouldNavigate || shouldShowPopup
                                            ? "pointer"
                                            : "default",
                                        padding: "2px 4px",
                                        display: "flex",
                                        alignItems: "center",
                                        opacity: isDragged ? 0 : 1,
                                        borderLeft:
                                          "1px solid rgba(0, 0, 0, 0.2)",
                                        borderRight:
                                          "1px solid rgba(0, 0, 0, 0.2)",
                                        borderTop: continuesFromPrevHour
                                          ? "none"
                                          : "1px solid rgba(0, 0, 0, 0.2)",
                                        borderBottom: continuesNextHour
                                          ? "none"
                                          : "1px solid rgba(0, 0, 0, 0.2)",
                                      }}
                                      onClick={(e) => {
                                        if (isDragging) {
                                          e.stopPropagation();
                                          return;
                                        }
                                        if (shouldNavigate) {
                                          const requestedDate =
                                            dateObj?.requestedDate;
                                          const canEdit =
                                            createdByMe ||
                                            (createdByOthers &&
                                              canEditAndViewOthersData(
                                                eventItem?.officeId,
                                              ));
                                          goToDetails(
                                            eventItem.id,
                                            eventItem.agendaType,
                                            canEdit,
                                            requestedDate,
                                          );
                                        } else if (shouldShowPopup) {
                                          setHoverKey(thisHoverKey);
                                        } else {
                                          toggleTooltip(tooltipId);
                                        }
                                      }}
                                    >
                                      {isFirstHourOfEvent && (
                                        <div
                                          style={{
                                            fontSize: 10,
                                            color: "#2D3245",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            width: "100%",
                                          }}
                                        >
                                          {renderEventContent(
                                            finalEvent,
                                            finalEvent.dotColor,
                                          )}
                                        </div>
                                      )}
                                    </div>
                                    <Tooltip
                                      placement="top"
                                      isOpen={
                                        openTooltipId === tooltipId &&
                                        !isDragged
                                      }
                                      target={tooltipId}
                                      autohide={false}
                                      toggle={() => toggleTooltip(tooltipId)}
                                      className="weekly_list_tooltip_style"
                                    >
                                      <div className={styles.tooltip_content}>
                                        <div
                                          className={styles.image_border}
                                          style={{
                                            border: `2px solid ${getOfficeColor(
                                              finalEvent.user,
                                              eventItem?.officeId,
                                              selectedOwnerId,
                                            )}`,
                                          }}
                                        >
                                          <img
                                            src={
                                              finalEvent.user.profilePic ||
                                              defautUserImage
                                            }
                                            onError={(e) => {
                                              e.currentTarget.src =
                                                defautUserImage;
                                            }}
                                            alt={eventItem?.title || ""}
                                            className={styles.tooltip_image}
                                          />
                                        </div>
                                        <div>
                                          <p className={styles.staff_name}>
                                            {finalEvent.user.fullName}
                                          </p>
                                          {renderOfficeNameOrEnterprise(
                                            eventItem,
                                            t,
                                          ) && (
                                            <div
                                              className={styles.chip}
                                              style={{
                                                backgroundColor: getOfficeColor(
                                                  finalEvent.user,
                                                  eventItem?.officeId,
                                                  selectedOwnerId,
                                                ),
                                                color: "#FFFFFF",
                                              }}
                                            >
                                              {renderOfficeNameOrEnterprise(
                                                eventItem,
                                                t,
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </Tooltip>
                                    {thisHoverKey === hoverKey &&
                                      shouldShowPopup &&
                                      getPopupView(
                                        eventItem,
                                        getBackgroundColorClass(eventItem),
                                        getTagColorClass(eventItem),
                                        dateObj?.requestedDate,
                                        finalEvent.user.fullName,
                                      )}
                                  </React.Fragment>
                                );
                              },
                            );
                          },
                        )}
                        {/* Drag preview for time-based events */}
                        {isDragging &&
                          dragPreviewPosition &&
                          !dragPreviewPosition.isAllDay &&
                          dragPreviewPosition.dayIndex === dIndex &&
                          dragPreviewPosition.hourIndex === hIndex &&
                          draggedEvent &&
                          draggedEvent.eventItem && (
                            <div
                              style={{
                                position: "absolute",
                                top: `${dragPreviewPosition.topPercent}%`,
                                left: 0,
                                width: "100%",
                                height: `${dragPreviewPosition.heightPercent}%`,
                                backgroundColor: getEventColor(
                                  draggedEvent.eventItem,
                                ),
                                border: `2px dashed ${getEventBorderColor(
                                  draggedEvent.eventItem,
                                )}`,
                                borderRadius: 6,
                                opacity: 0.6,
                                zIndex: 1000,
                                pointerEvents: "none",
                                display: "flex",
                                alignItems: "center",
                                padding: "2px 4px",
                              }}
                            >
                              <div
                                style={{
                                  fontSize: 10,
                                  color: "#2D3245",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  width: "100%",
                                }}
                              >
                                {draggedEvent.fullEvent
                                  ? renderEventContent(
                                      draggedEvent.fullEvent,
                                      draggedEvent.fullEvent?.dotColor ||
                                        "#005f99",
                                    )
                                  : renderEventContent(
                                      { item: draggedEvent.eventItem },
                                      "#005f99",
                                    )}
                              </div>
                            </div>
                          )}
                      </td>
                    );
                  })}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {editModalConfirmation && pendingDragUpdate && (
        <EditOptionsModal
          isOpen={editModalConfirmation}
          closeStepOneModal={setEditModalConfirmation}
          loader={isDragDropLoading}
          eventKey={
            pendingDragUpdate.isBusySlot
              ? {
                  eventOrShift: t("accountOwner.busySlot").toLowerCase(),
                }
              : {
                  eventOrShift: t(
                    `accountOwner.${
                      pendingDragUpdate.eventData?.isShift ? "shift" : "event"
                    }Tab`,
                  ).toLowerCase(),
                }
          }
          eventOrShiftTab={
            pendingDragUpdate.isBusySlot
              ? false
              : pendingDragUpdate.eventData?.isShift || false
          }
          busySlots={pendingDragUpdate.isBusySlot || false}
          repeatedOptionChanged={pendingDragUpdate.anyChangedForDate || false}
          handleConfirm={async (value) => {
            setIsDragDropLoading(true);
            try {
              if (pendingDragUpdate.isBusySlot) {
                await performBusySlotUpdate(
                  pendingDragUpdate.busySlotData,
                  pendingDragUpdate.newDateTime,
                  value,
                  pendingDragUpdate.officeDetails,
                  pendingDragUpdate.officeIds,
                  pendingDragUpdate.busySlotEmployeeView,
                  pendingDragUpdate.isAllDayBusy,
                  pendingDragUpdate.repeatedType,
                  pendingDragUpdate.repeatedEndDate,
                  pendingDragUpdate.originalRequestedDate,
                  pendingDragUpdate.UpdateFlags,
                );
              } else {
                await performEventUpdate(
                  pendingDragUpdate.eventData,
                  pendingDragUpdate.newDateTime,
                  value,
                  pendingDragUpdate.originalRequestedDate,
                );
              }
            } catch {
            } finally {
              // Error already shown in perform functions
              setEditModalConfirmation(false);
              setPendingDragUpdate(null);
              setIsDragDropLoading(false);
            }
          }}
        />
      )}
    </>
  );
}

export default withTranslation()(WeeklyListView);